import { CurrencyPipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AddressCargo } from "src/app/core/interfaces/addressCargo";
import { SatelliteTrackingService } from "src/app/core/services/satellite-tracking.service";
import { Cargo, SicetacResponse } from "src/app/core/interfaces/cargo";
import { Destination } from "src/app/core/interfaces/destination";
import {
  ResponseApproval,
  VerifyCargoApproval,
} from "src/app/core/interfaces/verifyCargoApproval";
import { DateFormatPipe } from "src/app/core/pipe/dateFormat.pipe";
import { PdfTitlePipe } from "src/app/core/pipe/pdfTitle.pipe";
import { Permission } from "src/app/core/resources/permission";
import { Titles } from "src/app/core/resources/titles";
import { Utils } from "src/app/core/resources/utils";
import { AuthService } from "src/app/core/services/authentication.service";
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { DialogComponent } from "src/app/shared/dialog/dialog.component";
import { OpenImgComponent } from "src/app/shared/open-img/open-img.component";
import { AdminUsersService } from "../../administration/admin-users/admin-users.service";
import { CargoDetailComponent } from "../cargo-detail/cargo-detail.component";
import { CargoDetailService } from "../cargo-detail/cargo-detail.service";
import { ExternalManifestCargoComponent } from "../cargo-detail/components/external-manifest-cargo/external-manifest-cargo.component";
import { FreightForwarderEvidenceService } from "../cargo-evidence/cargo-evidence.service";
import { CargoItemService } from "../cargo-item/cargo-item.service";
import { FreightListService } from "../cargo-list/cargo-list.service";
import { CargoTrackingService } from "../cargo-tracking/cargo-tracking.service";
import { DiscountsAndBonusesCargoComponent } from "../discounts-and-bonuses-cargo/discounts-and-bonuses-cargo.component";
import { AccountService } from "../../account/account.service";
import { User } from "src/app/core/interfaces/user";
import { VehiclesService } from "../../administration/vehicles/list-vehicles.service";
import { Vehicle } from "src/app/core/interfaces/vehicle";
import { AssignVehicleCargoComponent } from "../assign-vehicle-cargo/assign-vehicle-cargo.component";
import { ChangeCompanyComponent } from "../change-company/change-company.component";
import { CargoReteicaComponent } from "../cargo-reteica/cargo-reteica.component";
import { CargoRenewDatesComponent } from "../cargo-renew-dates/cargo-renew-dates.component";
import { RoundedCargoComponent } from "../rounded-cargo/rounded-cargo.component";
import { CargoHistoryNewsComponent } from "../cargo-history-news/cargo-history-news.component";
import { HttpErrorResponse } from "@angular/common/http";
import { Dialog } from "src/app/core/resources/dialog";
import { CargoUpdateComponent } from "../cargo-update/cargo-update.component";
import { VehicleManager } from "src/app/core/managers/vehicle.manager";
import { CargoLocationReportComponent } from "../cargo-location-report/cargo-location-report.component";
import { CargoService } from "src/app/core/services/cargo.service";
import { CompanyManager } from "src/app/core/managers/company.manager";
import { CargoManager } from "src/app/core/managers/cargo.manager";
import { environment } from "src/environments/environment";
import { PermissionRole } from "src/app/core/resources/permission-role";
import { CargoAdvancePercentageComponent } from "../cargo-advance-percentage/cargo-advance-percentage.component";
import { CargoRequestAdvanceComponent } from "../cargo-request-advance/cargo-request-advance.component";
import { EMPTY, Observable, Observer, of, Subscription } from "rxjs";
import { OptionsDialog } from "src/app/core/interfaces/options-dialog";
import { Traceability } from "src/app/core/interfaces/lastPointLocation";
import { CargoMessages } from "src/app/core/messages/cargo-messages.enum";
import { CargoStateDict, CargoStateEnum } from "src/app/core/enums/cargoState.enum";
import { DisableManifestReason } from "src/app/core/enums/manifestState.enum";
import { PDFTypes } from "src/app/core/enums/pdf-types.enum";
import { VehicleMessages } from "src/app/core/messages/vehicle-messages.enum";
import { CargoOptionsService } from "./cargo-options.service";
import { ServiceMessages } from "src/app/core/messages/service-messages.enum";
import { ReceivableService } from "../../administration/receivable/receivable.service";
import { finalize, map, switchMap } from "rxjs/operators";
import { ReceivableModificationsComponent } from "../../administration/receivable/receivable-modifications/receivable-modifications.component";
import { ModalEnum } from "src/app/core/enums/modal.enum";
import { UserClient } from "src/app/core/interfaces/userClient";
import { DateManager } from "src/app/core/managers/date.manager";
import { Fmt } from "src/app/core/messages/fmt";
import { UserManager } from "src/app/core/managers/user.manager";
import { Roles } from "src/app/core/enums/roles.enum";
import { CargoShippingCostDialogComponent } from "../cargo-shipping-cost-dialog/cargo-shipping-cost-dialog.component";
import { FormMessages } from "src/app/core/messages/form-messages.enum";
import { Company } from "src/app/core/interfaces/company";
import { ApproveCargoDialogComponent } from "src/app/shared/approve-cargo-dialog/approve-cargo-dialog.component";
import { CargoApprovalRequest } from "src/app/core/interfaces/cargo-approval-request";
import { ConfirmDriver } from "src/app/core/interfaces/confirmDriver";
import { ModificationReceivable } from "src/app/core/interfaces/modificationReceivable";
import { RequestDatesToMonitorComponent } from "../request-dates-to-monitor/request-dates-to-monitor.component";
import { BasicCompany } from "src/app/core/interfaces/basicCompany";
import { Gps } from "src/app/core/interfaces/gps";
import { MoveAdvanceDialogComponent } from "../move-advance-dialog/move-advance-dialog.component";
import { UserMessages } from "src/app/core/messages/user-messages.enum";
import { ExpiredDocuments } from "src/app/core/interfaces/expired-documents";
import { CompanyService } from "src/app/core/services/company.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AdditionalCertification } from "src/app/core/interfaces/additionalCertification";
import { AdditionalCertificationDict, AdditionalCertificationEnum } from "src/app/core/enums/additionalCertification.enum";
import { FIELDS_SECURITY_STUDY, FIELDS_STATE } from "src/app/core/config/user.config";
import { LinkServicesComponent } from "../link-services/link-services.component";
import { ReplicateServiceComponent } from "../replicate-service/replicate-service.component";
import { ServiceValidationManager } from "src/app/core/managers/service-validation.manager";
import { CargoRouteVisualizationComponent } from "../../service-request-form/components/cargo-route-visualization/cargo-route-visualization.component";
import { AssignSatelliteLockComponent } from "../assign-satellite-lock/assign-satellite-lock.component";
import { SatelliteLockService } from "../../satellite-lock/satellite-lock.service";
import { SatelliteLockInspection } from "src/app/core/interfaces/satelliteLockInspection";
import { SatelliteLock } from "src/app/core/interfaces/satelliteLock";
import { DialogSatelliteLockComponent } from "src/app/shared/dialog-satellite-lock/dialog-satellite-lock.component";
import { TravelExpense } from "src/app/core/interfaces/travel-expense";
import { TravelExpensesService } from "src/app/core/services/travel-expenses.service";
import { GeneralConfigService } from "src/app/core/services/general-config.service";
import { CargoPaymentsService } from "src/app/core/services/cargo-payments.service";
import { RNDC_CANCEL_MANIFEST_CONTINGENCY_BLOCKED_SNACKBAR, RNDC_CANCEL_MANIFEST_CONTINGENCY_BLOCKED_TOOLTIP, getRndcRequestFailureDisplayMessage, mergeCargoFromRndcResponse, shouldShowRndcIntermittencyAuthorizationDialog, } from "../../rndc/rndc-utils";

import { ConsignmentCargo } from "src/app/core/interfaces/consignmentCargo";
import { ChangeDriverComponent } from "../change-driver/change-driver.component";
import { DriverCargoService } from "../driver-cargo/driver-cargo.service";
import {
  DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE,
  isDocumentRecreationInProgress
} from "src/app/core/resources/transport-company-change.utils";
import { transportCompanyListQueryParams } from "src/app/core/resources/transport-company-context.utils";
import { SelectableItem } from "src/app/core/interfaces/selectableItem";


@Component({
  selector: "app-cargo-options",
  templateUrl: "./cargo-options.component.html",
  styleUrls: ["./cargo-options.component.scss"],
  providers: [
    CargoDetailService,
    CurrencyPipe,
    DateFormatPipe,
    VehicleManager,
    CargoManager,
    UserManager,
  ],
})
export class CargoOptionsComponent implements OnInit, OnChanges, OnDestroy {
  static GpsProviders: { [key: string]: { monitor: boolean, name: string, companyId: string, id: string } } = null;
  private static rndcContingencySub: Subscription | null = null;
  private static rndcContingencyInstances: Set<CargoOptionsComponent> = new Set<CargoOptionsComponent>();
  private static rndcContingencyActive: boolean = false;

  @Input() cargo: Cargo;
  @Input() isNegotiation: boolean;
  @Input() type: string;
  @Input() typeList: string = null;
  @Input() tracepoints: Traceability;
  @Output() refreshCargo = new EventEmitter<any>();
  @Output() refreshListCargo = new EventEmitter<any>();
  @Output() executeParentMethod = new EventEmitter<string>();
  @Output() openVehicle = new EventEmitter<string>();
  @Output() showInspection = new EventEmitter<string>();
  @Output() loadDeleted: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild(AssignVehicleCargoComponent)
  assignVehicleCargoComponent: AssignVehicleCargoComponent;
  @ViewChild(CargoDetailComponent)
  cargoDetailComponent: CargoDetailComponent;

  driver: User;
  vehicle: Vehicle;
  satelliteLock: SatelliteLock;
  permission = Permission;
  listActive = "";
  lastInspection;
  cannotShowManifestReason: string = DisableManifestReason.PRECONDITIONS_NOT_MET;
  cannotRequestAdvanceReason: string = CargoMessages.SHOW_REQUEST;
  canOpenRequestAdvanceModal = false;
  isRequestAdvanceDefined = false;
  flag: number = 0;
  disableViewManifest: boolean = true;
  public environment = environment;
  historyFlag: boolean = false;
  holder: any;
  pendingReceivables: string = "";
  allowCreatingWithoutTruora: boolean = false;
  listCompanies: BasicCompany[] = [];
  company: Company;
  isRootNit: boolean = false;
  private rndcContingencyActiveValue: boolean = CargoOptionsComponent.rndcContingencyActive;
  private isDestroyed: boolean = false;
  private rndcContingencySub: Subscription;
  readonly rndcCancelManifestBlockedTooltip = RNDC_CANCEL_MANIFEST_CONTINGENCY_BLOCKED_TOOLTIP;
  readonly documentRecreationInProgressMessage = DOCUMENT_RECREATION_IN_PROGRESS_MESSAGE;

  constructor(
    public titles: Titles,
    public cargoItemService: CargoItemService,
    public matDialog: MatDialog,
    public authService: AuthService,
    public utils: Utils,
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private cargoListService: FreightListService,
    private cargoTrackingService: CargoTrackingService,
    private pdfTitlePipe: PdfTitlePipe,
    private cargoDetailService: CargoDetailService,
    private adminUserService: AdminUsersService,
    private cargoEvidenceService: FreightForwarderEvidenceService,
    private router: Router,
    private dateFormatPipe: DateFormatPipe,
    private accountService: AccountService,
    private vehiclesService: VehiclesService,
    private satelliteLockService: SatelliteLockService,
    private dialog: Dialog,
    private vehicleManager: VehicleManager,
    private cargoService: CargoService,
    private companyManager: CompanyManager,
    private cargoManager: CargoManager,
    private satelliteTrackingService: SatelliteTrackingService,
    public permissionRole: PermissionRole,
    private cdref: ChangeDetectorRef,
    private cargoOptionsService: CargoOptionsService,
    public receivableService: ReceivableService,
    private userManager: UserManager,
    private activatedRoute: ActivatedRoute,
    private adminUsersService: AdminUsersService,
    private companyService: CompanyService,
    private serviceValidationManager: ServiceValidationManager,
    private travelExpensesService: TravelExpensesService,
    private generalConfigService: GeneralConfigService,
    private cargoPaymentsService: CargoPaymentsService,
    private driverCargoService: DriverCargoService,
    private currencyPipe: CurrencyPipe
  ) {
    this.cannotRequestAdvanceReason = "";
    this.isRootNit = this.authService && this.authService.userIsFromRootNit();
  }
  /**
  * This method set the list active taking into account the last list of the session storage.
  */
  ngOnInit() {
    this.registerRndcContingencyListener();
    this.company = this.authService && this.authService.getCompany();
    this.listCompanies = this.accountService.listRegisterCompanies();
    if (sessionStorage.getItem("_lastList")) {
      this.listActive = sessionStorage.getItem("_lastList").toString();
    }
    this.infoTruora();
  }

  /**
  * This method checks if the load have changes and if have changes change the historyflag.
  * @param {SimpleChanges} changes (SimpleChanges) read the changes of the inputs.
  */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.cargo && changes.cargo.currentValue) {
      this.historyFlag = false;
      this.loadCannotShowManifestReason();
      this.cdref.markForCheck();
    }
  }

  /**
  * This method will run after the content has been checked and most of the time it's during a change detection cycle
  */
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  /**
  * Fetches Truora entity info.
  */

  private infoTruora() {
    const holderCompany = this.companyService.holderCompany;
    if (holderCompany && holderCompany.companyId)
      this.allowCreatingWithoutTruora = !!(holderCompany && holderCompany.allowCreatingWithoutTruora);
  }
  /**
  * This method open a dialog window that allows the user to modify the advance percentage.
  */
  public openDialogNewAdvancePercentage() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(
      CargoAdvancePercentageComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      }
    });
  }
  /**
  * This method open a dialog window that allows the user to change the reteica percent of the load.
  */
  public openDialogChangeReteica() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Modificar Reteica",
      idCargo: this.cargo.id,
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(CargoReteicaComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      }
    });
  }
  /**
  * This method open a dialog window that render the novelties history detail of the load.
  */
  public openDialogHistory() {
    if (this.tracepoints) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: "Historial de novedades",
        tracepoints: this.tracepoints,
        cargo: this.cargo,
      };
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      const dialogRef = this.matDialog.open(
        CargoHistoryNewsComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe(() => {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
        this.executeParentMethod.emit('refreshLocations');
      });
    } else {
      this.snackBarService.openSnackBar(FormMessages.ERROR_OPEN_HISTORY, undefined, 'error');
    }
  }
  /**
  * This method brings the tracepoints of the load.
  */
  public getTracepoints() {
    this.spinner.show();
    this.cargoTrackingService.getTracking(this.cargo.id).subscribe(
      (data: Traceability) => {
        this.spinner.hide();
        if (data) {
          this.tracepoints = data;
          this.openDialogHistory();
        } else {
          this.openDialogError(FormMessages.NOT_REGISTERED_HISTORY);
        }
      },
      error => {
        this.spinner.hide();
        this.openDialogError(FormMessages.NOT_REGISTERED_HISTORY);
      })
  }

  /**
  * This method opens a dialog to confirm the removal of a cargo that is part of a consolidated service.
  * @returns {Promise<{ remove: 'all'|'one'|null }>} A promise that resolves to an object with the removal type or null if the user cancels.
  */
  private async confirmMultipleRemovalsCargo(): Promise<{ remove: 'all' | 'one' | null }> {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `Este servicio hace parte de un servicio consolidado`,
      iconAlert: true,
      descriptionHTML: `<p class="text-center">¿Desea eliminar el servicio consolidado y todos los servicios asociados o solo el servicio actual?</p>`,
      labelButton1: 'Eliminar todos',
      labelButton2: 'Eliminar actual',
      hideBtnCancel: true,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialog = this.matDialog.open(DialogComponent, dialogConfig);
    const result = await dialog.afterClosed().toPromise();
    if (!result || !result.state) return null;
    if (result.refuse && result.refuse === "Eliminar todos")
      return { remove: 'all' };
    if (result.refuse && result.refuse === "Eliminar actual")
      return { remove: 'one' };
    return null;
  }
  /**
  * This method open a dialog to confirm or reject the remove of the load.
  * @param {string} type (string - optional) optional parameter to redirect the user to different places in this case the only option is lowAgreedValue.
  */
  public async confirmRemoveCargo(type?: string) {
    if (this.blockDocumentMutation()) return;
    const hasPermissionRemovePaid: boolean = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.removeCargoWithPayments);
    const hasPayments: boolean = !!(this.cargo.shippingCost && this.cargo.shippingCost.payments && !!this.cargo.shippingCost.payments.length);
    if (hasPayments && !hasPermissionRemovePaid) return this.errorMessageDeleteCargo("Este servicio tiene pagos realizados, se requiere un permiso adicional para eliminarlo");
    const dialogConfig = new MatDialogConfig();
    const title =
      hasPayments ? 'Este servicio tiene pagos realizados, ¿Estás seguro que deseas eliminarlo?'
        : this.cargo.ministry && this.cargo.state !== CargoStateEnum.REQUEST
          ? `Este servicio tiene remesas, al eliminarlo se anularán ante el RNDC. ¿Estás seguro que deseas eliminarlo?`
          : `¿Estás seguro que deseas eliminar este servicio?`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const resultConfirm = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (!resultConfirm || !resultConfirm.state) return;

    let removeAll = false;
    if (this.utils.isDefined(this.cargo.consecutiveMainCargo)) {
      const result = await this.confirmMultipleRemovalsCargo();
      if (!result) return;
      if (result.remove === 'all') removeAll = true;
    }
    dialogConfig.data = {
      title:
        "Estas a un paso de anular el servicio, Nos gustaria conocer la razón por la cual se eliminará",
      textArea: true,
      placeholder: "Observacion",
    };
    const result2 = await this.matDialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
    if (result2 && result2.state) {
      this.removeCargo(result2.message, type, hasPayments && hasPermissionRemovePaid, removeAll);
    }
  }
  /**
  * This method consumes the service that delete a load.
  * @param {string} observation (string) is the reason of the user for delete the load.
  * @param {string} type (string - optional) is the value that indicates if need to redirect the user to other path.
  * @param {boolean} hasPaymentsAndPermission (boolean) is validation to know if the user have the permission to delete de load.
  */
  public removeCargo(observation: string, type?: String, hasPaymentsAndPermission: boolean = false, removeAll: boolean = false) {
    this.spinner.show();
    let infoExtra = {
      fingerPrint: {
        userId: this.authService
          .getUserSession()
          .information.document,
        userName: this.authService.getUserSession().information.name,
        date: DateManager.dateToString(new Date()),
      },
      observation: observation,
    };
    this.cargoDetailService
      .removeCargo(this.cargo.id, { body: infoExtra }, hasPaymentsAndPermission, removeAll)
      .subscribe(
        (data: any) => {
          this.spinner.hide();
          if (data && data.message) {
            if (data.message === "Deleted") {
              this.snackBarService.openSnackBar(
                "El servicio se eliminó correctamente"
              );
              if (type) {
                if (type === 'lowAgreedValue') this.router.navigate(['/cargo/create']);
                else if (type === 'fromAdvanceAlert') this.loadDeleted.emit(this.cargo.licensePlate);
              }
              else {
                this.goToList();
                this.refreshListCargo.emit();
              }
            } else this.snackBarService.openSnackBar(`Ocurrió un error al realizar el proceso con el servicio ${this.cargo.consecutive}: ${data.message}`, undefined, "error");
          }
          else {
            this.snackBarService.openSnackBar(
              `Ocurrió un error al realizar el proceso con el servicio: ${this.cargo.consecutive}`,
              undefined,
              "error"
            );
          }
        },
        (error) => {
          this.spinner.hide();
          const message = this.utils.getNestedValue(error, 'error.message');
          this.snackBarService.openSnackBar(
            message || `Ocurrió un error al realizar el proceso con el servicio: ${this.cargo.consecutive}`,
            undefined,
            "error"
          );
        }
      );
  }

  get showOptionEditAndDisassociate(): boolean {
    return this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.cashed;
  }
  /**
  * This method executes the dialog edit window of the specific bill element.
  */
  public editBill() {
    this.openDialogEdit("bill", "factura");
  }
  /**
  * This method executes the dialog edit window of the specific income element.
  */
  public editIncome() {
    this.openDialogEdit("income", "comprobante");
  }
  /**
  * This method executes the dialog confirmation window of dissasociation of the specific bill element.
  */
  public disassociateBill() {
    this.confirmDisassociate("bill", "factura");
  }
  /**
 * This method executes the dialog confirmation window of dissasociation of the specific income element.
 */
  public disassociateIncome() {
    this.confirmDisassociate("income", "comprobante");
  }

  /**
  * This method is to confirm the disassociation of the element could be bill or income.
  * @param {string} type (string) is type of element to dissasociate bill or income.
  * @param {string} data (string) the name of the element to dissasociate.
  */
  public confirmDisassociate(type: string, data: string) {
    const dialogConfig = new MatDialogConfig();
    const title = `¿Estás seguro que deseas desasociar ${data} seleccionad${type === 'bill' ? 'a' : 'o'}?`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        let ids = [this.cargo.id];
        this.disassociate(ids, type);
      }
    });
  }
  /**
  * This method open a dialog window that allows the user to modify the bill or the income element.
  * @param {string} type (string) is type of element could be bill or income.
  * @param {string} data (string) is the label that the user would see.
  */
  public openDialogEdit(type: string, data: string) {
    const dialogConfig = new MatDialogConfig();
    const title = `Modificar ${data}`;
    dialogConfig.data = {
      title: title,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(CargoUpdateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (this.utils.isDefined(result)) {
        let ids = [this.cargo.id];
        this.updateInvoice(ids, type, result);
      }
    });
  }
  /**
  * This method comsumes the service that modify the invoice number.
  * @param {string[]} idCargos (string[]) are the identifiers of the loads that needs to modify.
  * @param {string} type (string) is the type of element could be: bill or income.
  * @param {string} value (string) is the new invoice number that wants to set.
  */
  public updateInvoice(idCargos: string[], type: string, value: string) {
    this.spinner.show();
    this.cargoDetailService.editInvoice(idCargos, type, value).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (data && data.message) {
          this.snackBarService.openSnackBar(data.message);
          this.refreshListCargo.emit();
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          `Ocurrió un error al desasociar`,
          undefined,
          "error"
        );
      }
    );
  }

  /**
  * This method allows to dissasociate the bill or income.
  * @param {string[]} idCargos (string[]) the ids of the loads that wants to dissasociate.
  * @param {string} type (string) is type of element to dissasociate bill or income.
  */
  public disassociate(idCargos: string[], type: string) {
    this.spinner.show();
    this.cargoDetailService.disassociate(idCargos, type).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (data && data.message) {
          this.snackBarService.openSnackBar(data.message);
          this.refreshListCargo.emit();
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          `Ocurrió un error al desasociar`,
          undefined,
          "error"
        );
      }
    );
  }
  /**
  * This method redirect de user depends on the active list.
  */
  public goToList() {
    const paymentCargoList = [
      "paymentAdvanceCargo",
      "paymentExtraAdvanceCargo",
      "paymentAdditionalCostsCargo",
      "paymentBalanceCargo"
    ]
    const loadingRoutesList = [
      'loadingRoutes',
      'emptyContainers',
      'urbanRoutes',
      'lastMileRoutes',
      'nationalRoutes',
      'exportRoutes',
      'importRoutes',
      'internationalRoutes'
    ];
    const queryParams = transportCompanyListQueryParams(this.listActive, this.cargo);
    if (paymentCargoList.includes(this.listActive)) {
      this.router.navigate(["cargo/list/paymentCargo"], { queryParams });
    } else if (loadingRoutesList.includes(this.listActive)) {
      this.router.navigate(["cargo/list/loadingRoutes"]);
    } else {
      this.router.navigate(["cargo/list/" + this.listActive], { queryParams });
    }
  }

  /**
  * This method verify if the load could credit to receivable.
  * @param {Cargo[]} cargos (Cargo[]) are the list of loads sended to verify receivables.
  */
  verifyReceivableModifications(cargos: Cargo[]) {
    const dialogConfig = new MatDialogConfig();
    let title = '';
    if (cargos && cargos[0] && cargos[0].message) {
      title = `${cargos[0].message}. ¿Desea hacer el abono a la cartera?`;
    }
    dialogConfig.data = {
      title: title,
      showYesBtn: true,
      showNoBtn: true
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.receivableList(cargos[0].licensePlate);
      }
    });
  }
  /**
  * This method brings the information of the receivables according to the information of the vehicle.
  * @param {string} licensePlate (string) is the license plate of the vehicle that needs to know the receivables associated.
  */
  receivableList(licensePlate: string) {
    let observableVehicleInfo;
    const $observerVehicleInfo = {
      next: (vehicle: Vehicle) => {
        if (vehicle && vehicle.bankAccountBalance) {
          this.holder = {
            name: vehicle.bankAccountBalance.name,
            document: vehicle.bankAccountBalance.document,
            documentTypeName: vehicle.bankAccountBalance.documentTypeName
          };
          let debtor = this.authService.createHolderObjReceivables(vehicle);
          return this.receivableService.getReceivableList(null, null, vehicle.bankAccountBalance.document, null, null, 'list', debtor && debtor.document ? debtor.document : null);
        } else {
          this.snackBarService.openSnackBar('No existe un usuario asociado al balance de la cuenta', undefined, "error")
          return of(null);
        }
      },
      error: () => {
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        return EMPTY;
      },
      finally: () => {
        this.spinner.hide();
        observableVehicleInfo.unsubscribe();
      }
    };
    this.spinner.show();
    const observableVehicle = this.vehiclesService.getVehicleFromOwnCompany(licensePlate).pipe(switchMap(vehicle => observableVehicleInfo = $observerVehicleInfo.next(vehicle)))
      .subscribe({
        next: (listModifications: ModificationReceivable) => {
          this.spinner.hide();
          if (listModifications) {
            this.openModificationsList(listModifications);
          } else {
            this.snackBarService.openSnackBar("No hay modificaciones para mostrar", undefined, "alert")
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.snackBarService.openSnackBar("Hubo un error trayendo las modificaciones. Vuelva a intentarlo", undefined, "alert")
        },
        complete: () => {
          this.spinner.hide();
          observableVehicle.unsubscribe();
        }
      })
  }
  /**
  * This method open a dialog window that shows to the user the detail of the modifications of a receivable associate to the load and also asks the user if wanted to approve or reject a modification in the receivable.
  * @param {ModificationReceivable} listReceivables (ModificationReceivable) is the list of modifications available to this receivable.
  */
  openModificationsList(listReceivables: ModificationReceivable) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      listReceivables: listReceivables,
      holder: this.holder
    }
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.disableClose = true;
    const dialogRef = this.matDialog.open(ReceivableModificationsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'undefined') {
        this.snackBarService.openSnackBar('Por favor rechace o apruebe la modificacion a la cartera para poder continuar', undefined, 'alert')
      }
    })
  }
  /**
  * This method verifies the state of the approval of the load.
  * @param {Cargo[]} cargos (Cargo[]) are the list of loads sended to approve o reject.
  * @param {boolean} state (boolean) is the approval state could be: approval or rejected.
  */
  verifyCargoApprovalResponse(cargos: Cargo[], state: boolean) {
    const response: VerifyCargoApproval = {
      RNDCError: [],
      generalError: [],
      generalSuccess: [],
    };
    cargos.map((cargo: Cargo) => {
      if (cargo.manifestError && cargo.manifestError.error && !this.rndcContingencyActive) {
        response.RNDCError.push({
          title: `Consecutivo: ${cargo.consecutive}`,
          message: cargo.manifestError.error,
        });
      }
      cargo.cargoFeature.uploadDownload.origin.addresses.map(
        (address: AddressCargo, i: number) => {
          if (address.ministryError && address.ministryError.error && !this.rndcContingencyActive) {
            response.RNDCError.push({
              title: `Dirección Origen ${i + 1}: ${address.address}`,
              message: address.ministryError.error,
            });
          }
        }
      );
      cargo.cargoFeature.uploadDownload.destination.map(
        (destination: Destination) => {
          destination.addresses.map((address: AddressCargo, i: number) => {
            if (address.ministryError && address.ministryError.error && !this.rndcContingencyActive) {
              response.RNDCError.push({
                title: `Dirección Destino ${i + 1}: ${destination.name} - ${address.address
                  }`,
                message: address.ministryError.error,
              });
            }
          });
        }
      );
      if (response.RNDCError.length === 0) {
        if (
          cargo.approval &&
          cargo.approval !== "Approved" &&
          cargo.approval !== "Rejected"
        ) {
          response.generalError.push({
            title: `Consecutivo: ${cargo.consecutive}`,
            message: "El servicio no ha sido aprobado. Ha quedado pendiente por aprobación.",
          });
        } else {
          response.generalSuccess.push({
            title: `Consecutivo: ${cargo.consecutive}`,
            message: `Se ha ${state ? "aprobado" : "rechazado"
              } el servicio correctamente`,
          });
        }
      }
    });
    if (response.RNDCError.length) {
      this.showResponseApproval(false, response.RNDCError);
    } else {
      if (response.generalError.length) {
        this.showResponseApproval(false, response.generalError);
      } else {
        this.showResponseApproval(true, response.generalSuccess);
      }
    }
    if (cargos[0].message && (cargos[0].approval === 'Approved' || cargos[0].approval === 'Rejected')) {
      this.verifyReceivableModifications(cargos);
    }
  }
  /**
  * This method open a dialog window that shows errors related with the approval of the load.
  */
  showResponseApproval(
    stateResponse: boolean,
    messageList: ResponseApproval[]
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Resultado de la operación",
      hideBtnCancel: true,
    };
    if (stateResponse) {
      dialogConfig.data.icon = true;
    } else {
      dialogConfig.data.iconError = true;
    }
    if (messageList.length) {
      dialogConfig.data.messageList = messageList.map(
        (item: ResponseApproval) => {
          return `${item.title} = ${item.message}`;
        }
      );
    }
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      this.refreshListCargo.emit();
      this.refreshCargo.emit(this.cargo.consecutive);
    });
  }

  /**
  * This method open a dialog window that allows to reverse the approval of a load.
  */
  async openModalReturnApproveCargo() {
    if (this.cargo.approval === "Approved") {
      const result = await this.cargoManager.preventContinueCargosWithBill([this.cargo]);
      if (!result || !result.continueAnyway) return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title:
        this.titles.titlenModalReturnApproveCargo +
        this.cargo.consecutive +
        " ?",
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        const data: CargoApprovalRequest = {
          cargos: [{ cargoId: this.cargo.id }],
          userId: this.authService
            .getUserSession()
            .information.document,
          userName: this.authService
            .getUserSession()
            .information.name,
        };
        this.spinner.show();
        this.cargoListService.approvedCargo(data).subscribe(
          (success) => {
            this.spinner.hide();
            this.refreshListCargo.emit();
            this.refreshCargo.emit(this.cargo.consecutive);
            this.snackBarService.openSnackBar(
              "Se ha reversado el estado exitosamente"
            );
          },
          (error) => {
            this.spinner.hide();
            this.snackBarService.openSnackBar(
              `Ocurrió un error al reversar el servicio: ${this.cargo.consecutive}`,
              undefined,
              "error"
            );
          }
        );
      }
    });
  }

  /**
  * This method open a dialog that shows the detail of the load.
  */
  async openDetailCargo() {
    let cargo: Cargo;
    this.spinner.show();
    try { cargo = await this.cargoDetailService.detailCargo(this.cargo.id).toPromise(); } catch (error) { }
    this.spinner.hide();
    if (!cargo) return this.snackBarService.openSnackBar(`Ocurrió un error intentando acceder al detalle del servicio`, undefined, "error");
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: cargo,
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(CargoDetailComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined) {
        if (this.type === 'button') {
          this.refreshCargo.emit(this.cargo.consecutive);
        } else {
          this.goToList();
          this.refreshListCargo.emit();
        }

      }
    });
  }

  /**
  * This method open a dialog window that allows the user to change the company of the load.
  */
  openChangeCompany() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.utils.clone(this.cargo),
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(ChangeCompanyComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.snackBarService.openSnackBar(
          "Se ha cambiado la compañía correctamente"
        );
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      } else if (result && result.state === false) {
        this.snackBarService.openSnackBar(
          `Ocurrió un error al cambiar de compañía a este servicio (${this.cargo.consecutive})`,
          undefined,
          "error"
        );
      }
    });
  }

  /**
  * This method open a dialog window that shows the detail of the bonus and discounts of the load.
  */
  async openDiscountsAndBonuses() {
    this.spinner.show();
    const balance = await this.balance();
    this.spinner.hide();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
      balance: balance,
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(
      DiscountsAndBonusesCargoComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state && result.dataCargo) {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
        const currentPath = this.activatedRoute.snapshot.url.map(segment => segment.path).join('/');
        const containsDetail = currentPath.includes('detail');
        let targetPath: string;
        if (containsDetail) {
          targetPath = this.cargo.state === CargoStateEnum.REQUEST
            ? `service-request-form/menu-service/${this.cargo.consecutive}`
            : `cargo/detail/${this.cargo.consecutive}`;
        } else {
          targetPath = `cargo/tracking/${this.cargo.consecutive}`;
        }
        this.belowSicetac(result.dataCargo, targetPath);
      }
    });
  }

  openDialogSatelliteLock() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(AssignSatelliteLockComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      }
    });
  }

  /**
  * This method open a dialog window that allows the user to load the external manifest of the load.
  */
  openLoadExternalManifest() {
    if (this.blockDocumentMutation()) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Cargar Manifiesto Externo",
      cargo: this.utils.clone(this.cargo),
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(
      ExternalManifestCargoComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      }
    });
  }
  /**
  * This method open a dialog window that shows the detail of the external manifest if the load have.
  */
  openExternalManifest() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: this.cargo.manifest,
      src: this.cargo.externalManifest,
      storage: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(OpenImgComponent, dialogConfig);
  }

  /**
  * This method brings a pdf taking into account the pdfType could be: order vehicle, manifest, consignment, urban manifest and urban consignment.
  * @param {string} pdfType (string) could be: order vehicle, manifest, consignment, urban manifest and urban consignment.
  */
  openCargoPDF(pdfType: string) {
    this.spinner.show();
    this.cargoTrackingService
      .getCargoPDF(pdfType.replace("_urban", ""), this.cargo.id)
      .subscribe(
        (success: any) => {
          this.spinner.hide();
          const newBlob: Blob = new Blob([success], { type: "application/pdf" });
          if (window.navigator && window.navigator["msSaveOrOpenBlob"]) {
            window.navigator["msSaveOrOpenBlob"](newBlob);
            return;
          }
          this.openModalCargoPDF(pdfType, newBlob);
        },
        (error) => {
          this.refreshListCargo.emit();
          this.refreshCargo.emit(this.cargo.consecutive);
          this.spinner.hide();
          this.snackBarService.openSnackBar(
            `Ocurrió un error al traer el PDF del servicio: ${this.cargo.consecutive}`,
            undefined,
            "error"
          );
        }
      );
  }
  /**
  * This method open a dialog window that render a pdf depends on the pdfType.
  * @param {string} pdfType (string) is the pdfType could be: order vehicle, manifest, consignment, urban manifest and urban consignment.
  * @param {Blob} newBlob (Blob) sends the blob of the resource that want to render.
  */
  openModalCargoPDF(pdfType: string, newBlob: Blob) {
    const dialogConfig = new MatDialogConfig();
    let realTitle = this.pdfTitlePipe.transform(pdfType.replace("_urban", ""));
    if (realTitle === 'Orden de servicio' && this.isTransportService)
      realTitle = 'Orden de cargue';
    dialogConfig.data = {
      title: realTitle,
      src: window.URL.createObjectURL(newBlob),
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(OpenImgComponent, dialogConfig);
  }

  async openCancelManifest() {
    if (this.blockDocumentMutation()) return;
    const blockedByContingency = this.rndcContingencyActive && !!this.cargo && !this.cargo.manifestAuthorization;
    if (blockedByContingency) {
      this.snackBarService.openSnackBar(RNDC_CANCEL_MANIFEST_CONTINGENCY_BLOCKED_SNACKBAR, undefined, 'alert');
      return;
    }
    const response = await this.companyManager.openDialogConfirmWithDescription(`¿Estás seguro que deseas anular el manifiesto?`, "Motivo de la anulación");
    if (!response.confirm) return;
    if (this.utils.isDefined(this.cargo.consecutiveMainCargo)) {
      const response = await this.companyManager.openDialogConfirm(`Se anulará el manifiesto en los demás servicios asociados, ¿Deseas continuar?`);
      if (!response.confirm) return;
    }
    if (this.blockDocumentMutation()) return;
    this.spinner.show();
    let success = null;
    try {
      success = await this.cargoDetailService.cancelManifest({ manifestNumber: this.cargo.manifest, observations: response.description, isNational: !this.utils.isSameCity(this.cargo) }).toPromise();
      this.spinner.hide();
      this.snackBarService.openSnackBar("Manifiesto anulado correctamente");
      this.refreshListCargo.emit();
      this.refreshCargo.emit(this.cargo.consecutive);
    } catch (error) {
      this.spinner.hide();
      const errorMessage = error && error.error && error.error.message
        ? error.error.message
        : "Ocurrió un error al anular el manifiesto";
      this.snackBarService.openSnackBar(errorMessage, undefined, "error");
    }
  }

  async cancelConsignment() {
    if (this.blockDocumentMutation()) return;
    const consignments = await this.getCargoConsignments();
    if (!consignments || !consignments.length)
      return this.snackBarService.openSnackBar(`No es posible anular ${this.consignmentAssociated > 1 ? 'las remesas asociadas' : 'la remesa asociada'} a este servicio`, undefined, "error");
    let consignmentsToDelete: ConsignmentCargo[] = [];
    if (this.consignmentAssociated > 1) {
      const response = await this.cargoManager.openDialogSelectConsignments(
        consignments,
        `¿Estás seguro que deseas anular ${this.consignmentAssociated > 1 ? 'las remesas' : 'la remesa'}?`,
        `Selecciona las remesas que deseas anular`
      );
      if (!response || !response.length) return;
      consignmentsToDelete = response;
    } else {
      const response = await this.cargoManager.openDialogConfirm(`¿Estás seguro que deseas anular la remesa ${consignments[0].id}?`);
      if (!response.confirm) return;
      consignmentsToDelete = [consignments[0]];
    }
    if (this.blockDocumentMutation()) return;
    this.spinner.show();
    const promises = consignmentsToDelete.map((consignment) => this.cargoDetailService.deleteConsignment(consignment.documentId, this.cargo.id).toPromise());
    try {
      await Promise.all(promises);
    } catch (error) {
      this.spinner.hide();
      this.snackBarService.openSnackBar(`Ocurrió un error al anular ${consignmentsToDelete.length > 1 ? 'las remesas' : 'la remesa'}`, undefined, "error");
    }
    this.spinner.hide();
    this.snackBarService.openSnackBar(`${consignmentsToDelete.length > 1 ? 'Remesas anuladas' : 'Remesa anulada'} correctamente`);
    this.refreshListCargo.emit();
    this.refreshCargo.emit(this.cargo.consecutive);
  }
  /**
  * This method open a dialog window that shows the detail of the history of payments.
  */
  openHistoryPayments() {
    const config = new MatDialogConfig();
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.MEDIUM_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;
    config.autoFocus = false;
    config.data = {
      shippingCostToDisplay: this.cargoDetailService.getHistoryPaid(this.cargo),
      cargo: this.cargo,
      typePayment: 'Payments'
    };
    this.matDialog
      .open(CargoShippingCostDialogComponent, config)
      .afterClosed()
      .subscribe((response) => {
        if (response && response.state) {
          this.refreshListCargo.emit();
          this.refreshCargo.emit(this.cargo.consecutive);
        }
      });
  }

  get canAssignVehicles(): { show: boolean, can?: boolean, reason?: string } {
    if (!this.cargo) return { show: false };
    if (!this.isTransportService && !this.isEscortedService) return { show: false };
    if (this.isNegotiation) return { show: false };
    if (this.cargo.confirmedDriver) return { show: false };
    if (this.cargo.licensePlate || this.cargo.assignedDriver) return { show: true, can: false, reason: 'El servicio ya tiene un vehículo asignado' };
    const permissionSpecialLicensePlate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.specialLicensePlate);
    const permissionAssignLicensePlate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.assignLicensePlate);
    if (!permissionSpecialLicensePlate && !permissionAssignLicensePlate) return { show: false };
    return { show: true, can: true };
  }
  get showAssignVehicleBtn(): { show: boolean, can?: boolean, reason?: string } {
    const canAssignVehicles = this.canAssignVehicles;
    if (!canAssignVehicles.show) return { show: false };
    if (![CargoStateEnum.CREATED].includes(this.cargo.state as CargoStateEnum)) return { show: false };
    if (!canAssignVehicles.can) return { show: true, can: false, reason: canAssignVehicles.reason };
    const isReserved = this.cargo && this.cargo.zone === 'reserved';
    const numberOfOffers = !!this.utils.getNestedValue(this.cargo, 'numberOfOffers');
    if (this.isTeclogiUser && !isReserved && numberOfOffers)
      return { show: true, can: false, reason: 'Hay postulaciones disponibles para este servicio, revísalas en "Buscar postulaciones"' };
    return { show: true, can: true };
  }
  get showFindApplicationsBtn(): { show: boolean, can?: boolean, reason?: string } {
    const canAssignVehicles = this.canAssignVehicles;
    if (!canAssignVehicles.show) return { show: false };
    if (![CargoStateEnum.CREATED, CargoStateEnum.REQUEST].includes(this.cargo.state as CargoStateEnum)) return { show: false };
    if (!canAssignVehicles.can) return { show: true, can: false, reason: canAssignVehicles.reason };
    const isReserved = this.cargo && this.cargo.zone === 'reserved';
    if (isReserved) return { show: true, can: false, reason: 'Los servicios con publicación reservada deben ser asignados desde la opción "Asignar vehículo"' };
    return { show: true, can: true };
  }

  get visualNumberOfOffers(): string {
    if (!this.cargo || !this.cargo.numberOfOffers || this.cargo.numberOfOffers <= 0) return null;
    if (this.cargo.numberOfOffers >= 100) return '+99';
    return `${this.cargo.numberOfOffers}`;
  }

  get showConfirmLicensePlateBtn(): boolean {
    const lockImei = this.utils.getNestedValue(this.cargo, 'lock.imei');
    const minRequirements = !this.isNegotiation && this.cargo && (this.cargo.driver || lockImei) && !this.cargo.confirmedDriver && [CargoStateEnum.ACCEPTED].includes(this.cargo.state);
    if (!minRequirements) return false;
    const isSpecialLicensePlate = this.cargo.licensePlate === "C0N111";
    const isLowRiskLicensePlate = this.utils.getNestedValue(this.cargo, 'riskProfile.name') === "Riesgo bajo";
    const hasPermissionSpecialLicensePlate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.specialLicensePlate);
    const hasPermissionConfirmLicensePlate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.confirmLicensePlate);
    const hasPermissionConfirmLicensePlateOfLowRiskCargo = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.confirmLicensePlateOfLowRiskCargo);
    if (isSpecialLicensePlate)
      return hasPermissionSpecialLicensePlate;
    if (isLowRiskLicensePlate && hasPermissionConfirmLicensePlateOfLowRiskCargo)
      return true;
    return hasPermissionConfirmLicensePlate;
  }

  get showDisassociateVehicleBtn(): boolean {
    if (!this.cargo || this.isNegotiation) return false;
    if (!this.cargo.driver || this.cargo.consecutiveMainCargo) return false;
    if (this.isSatelliteLockService) return false;
    return [CargoStateEnum.ACCEPTED, CargoStateEnum.CREATED, CargoStateEnum.REQUEST].includes(this.cargo.state);
  }

  get canAssignSecondDriver(): { show: boolean, canAssign?: boolean, reason?: string } {
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.changeAssignSecondDriver)) return { show: false };
    if (!this.cargo || !this.cargo.driver || !this.cargo.licensePlate) return { show: false };
    if (this.isSatelliteLockService || this.isEscortedService) return { show: false };
    if (this.cargo.secondDriver) return { show: true, canAssign: false, reason: 'Ya tiene un segundo conductor asignado' };
    if (![CargoStateEnum.ACCEPTED, this.cargoStateEnum.START_SERVICE].includes(this.cargo.state))
      return { show: true, canAssign: false, reason: 'El servicio debe estar programado o en servicio para asignar un segundo conductor' };
    if (this.utils.isSameCity(this.cargo)) return { show: true, canAssign: false, reason: 'No es posible asignar un segundo conductor en servicios nacionales' };
    return { show: true, canAssign: true };
  }
  /**
  * This method validates if the user could start the load.
  * @returns {boolean} (boolean) returns if whether or not the user is enabled to start the service.
  */
  get showStartServiceBtn(): boolean {
    const lockImei = this.utils.getNestedValue(this.cargo, 'lock.imei');
    const minRequirements = !this.isNegotiation && (this.cargo.driver || lockImei) && this.cargo.confirmedDriver && [CargoStateEnum.ACCEPTED].includes(this.cargo.state);
    if (!minRequirements) return false;
    if (this.cargo && this.cargo.licensePlate === "C0N111") return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.specialLicensePlate
    )
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.startCargo
    )
  }
  public disassociateVehicle() {
    const hasGeneratedManifest = this.cargo && this.cargo.ministry && this.cargo.manifestAuthorization && this.cargo.rndcTransmited;
    if (hasGeneratedManifest)
      return this.openDialogManifestBlocksDissociation();
    this.spinner.show();
    this.cargoDetailService.cancelCargo({
      cargoId: this.cargo.id,
      userId: this.cargo.driver,
    }).subscribe(
      (data) => {
        this.spinner.hide();
        if (data) {
          this.snackBarService.openSnackBar('Vehículo desasociado correctamente');
          this.refreshCargo.emit(this.cargo.consecutive);
          this.refreshListCargo.emit();
        } else {
          this.snackBarService.openSnackBar('Ocurrió un error al realizar el proceso', undefined, 'error');
        }
      },
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar('Ocurrió un error al realizar el proceso', undefined, 'error');
      }
    );
  }

  private openDialogManifestBlocksDissociation() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'No se puede desasociar el vehículo',
      description: 'Este servicio cuenta con un manifiesto generado. Es necesario anular el manifiesto antes de desasociar el vehículo.',
      hideBtnCancel: true,
      iconError: true,
    };
    dialogConfig.height = 'auto';
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  /**
  * This method open a dialog window that asks the user if wanted to confirm the vehicle.
  */
  openModalConfirmDriver() {
    const loadObservable = this.isSatelliteLockService ? this.loadSatelliteLock() : this.loadVehicle();
    loadObservable.subscribe({
      complete: () => {
        //No hay inspección vehícular
        const assignment = this.isEscortedService ? 'escolta' : this.isSatelliteLockService ? 'candado satelital' : 'vehículo';
        if (!this.lastInspection || !this.lastInspection.id) {
          const whoDocument = this.cargo.assignedVehicleFingerPrint
            ? this.cargo.assignedVehicleFingerPrint.userId
            : this.cargo.numberDocumentCreatorLoad;
          if (this.authService && whoDocument === this.authService.getUserSession().information.document) {
            return this.isSatelliteLockService ? this.openPreoperationalInspectionModal() : this.createInspection();
          }

          const who = this.cargo.assignedVehicleFingerPrint
            ? this.cargo.assignedVehicleFingerPrint.userName
            : `el Operador que asignó el ${assignment}`;

          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            title: `No se encontró registrada una inspección preoperacional del ${assignment}. 
            Debes comunicarte con ${who} para solicitar el registro de la inspección.`,
            hideBtnCancel: true,
          };
          dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
          dialogConfig.width = ModalEnum.SMALL_WIDTH;
          dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
          dialogConfig.autoFocus = false;
          this.matDialog.open(DialogComponent, dialogConfig);
          return;
        }
        //Tiene inspección vehícular pero no está aprobada
        if (!this.utils.isDefined(this.lastInspection.approval) || !this.lastInspection.approval) {
          if (this.canApprovePreoperationalInspection(this.lastInspection)) {
            this.openInspectionApprovalAndContinue();
            return;
          }
          if (!this.utils.isDefined(this.lastInspection.approval))
            return this.snackBarService.openSnackBar(`Aún no se ha aprobado la Inspección preoperacional del ${assignment}`, undefined, "alert");
          return this.snackBarService.openSnackBar(`La Inspección preoperacional del ${assignment} está rechazada`, undefined, "error");
        }
        this.validateReceivables();
      },
      error: () => { this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error') }
    });
  }

  private canApprovePreoperationalInspection(inspection): boolean {
    if (!inspection || !inspection.id) return false;
    if (!this.utils.isDefined(inspection.approval)) return true;
    if (!inspection.approval)
      return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approveRejectedInspection);
    return false;
  }

  private async openInspectionApprovalAndContinue(): Promise<void> {
    const userSession = this.authService.getUserSession();
    if (this.isSatelliteLockService) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        cargo: this.cargo,
        satelliteLock: this.cargo.lock,
        inspection: this.lastInspection,
        isViewInspection: true,
        canApprove: this.canApprovePreoperationalInspection(this.lastInspection),
      };
      dialogConfig.width = ModalEnum.SMALL_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.autoFocus = false;
      await this.matDialog.open(DialogSatelliteLockComponent, dialogConfig).afterClosed().toPromise();
      try {
        this.lastInspection = await this.cargoDetailService.getSatelliteLockInspection(this.cargo.id).toPromise();
      } catch (error) { }
    } else {
      await this.cargoManager.openExistingVehicleInspection({
        cargo: this.cargo,
        inspection: this.lastInspection,
        licensePlate: this.cargo.licensePlate,
        user: (userSession && userSession.information) || null
      });
      if (this.cargo && this.cargo.vehicleInspection) {
        try {
          this.lastInspection = await this.cargoItemService.getInspection(this.cargo.vehicleInspection, 'vehicle').toPromise();
        } catch (error) { }
      }
    }
    if (this.lastInspection && this.lastInspection.approval)
      this.validateReceivables();
  }

  private async openPreoperationalInspectionModal(): Promise<boolean> {
    const dialogConfig = new MatDialogConfig();
    const userSession = this.authService.getUserSession();
    dialogConfig.data = {
      satelliteLock: this.cargo.lock,
      cargo: this.cargo,
      user: (userSession && userSession.information) || null,
      isPreoperationalInspection: true,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;

    const result = await this.matDialog.open(DialogSatelliteLockComponent, dialogConfig).afterClosed().toPromise();
    return (result && result.state);
  }

  /**
  * This method checks the inspection of the load and if this is neccesary for this type of load.
  */
  private createInspection() {
    this.cargoManager.checkInspection(this.cargo, this.authService.getUserSession().information, this.cargo.licensePlate)
      .then((state) => {
        if (state) {
          this.openModalConfirmDriver();
        }
      }).catch(() => { });
  }
  /**
 * This method configure the information of a dialog that asks the user if wanted to continue without an inspection.
 * @returns {Promise<any>} (Promise<any>) returns the action of open a dialog.
 */
  confirmContinueWithoutContainerInspection(): Promise<any> {
    const config: OptionsDialog = {
      title: "No hay inspección de contenedor",
      description:
        "No hay ninguna inspección de contenedor para este servicio o no ha sido aprobada, ¿Desea continuar de todas formas?",
    };
    return this.dialog.openDialog(config).then().catch(err => err);
  }
  /**
  * This method open a dialog that asks to the user the confirmation or reject of the driver and the load.
  */
  dialogConfirmDriver() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: this.titles.titleConfirmDriver,
      subtitle: this.pendingReceivables ? this.pendingReceivables : '',
      licen: this.pendingReceivables ? '' : this.cargo.licensePlate,
      idCargo: this.pendingReceivables ? '' : this.cargo.consecutive,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = this.pendingReceivables ? ModalEnum.LARGE_WIDTH : ModalEnum.MEDIUM_WIDTH;
    const dialoRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialoRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        const data: ConfirmDriver = {
          cargoId: this.cargo.id,
          fingerprint: {
            userId: this.authService
              .getUserSession()
              .information.document,
            userName: this.authService
              .getUserSession()
              .information.name,
          },
        };
        const approval = result.refuse;
        this.confirmDriver(data, approval);
      }
    });
  }

  async dialogConfirmSatelliteLock() {
    const imei = this.utils.getNestedValue(this.cargo, 'lock.imei');
    const id = this.utils.getNestedValue(this.cargo, 'lock.id');
    const response = await this.cargoManager.openDialogConfirm(
      `Confirmación de candado satelital`,
      `¿Deseas confirmar el candado satelital de IMEI ${imei} y ID ${id} para este servicio?`
    );
    if (!response.confirm) return;
    this.confirmDriver({
      cargoId: this.cargo.id,
      fingerprint: {
        userId: this.authService.getUserSession().information.document,
        userName: this.authService.getUserSession().information.name,
      },
    }, "true");
  }
  /**
  * This method allows to confirm the license plate and driver assigned to the load in the scheduled loads.
  * @param {ConfirmDriver} data (ConfirmDriver) is the data related with the user that confirm the assignation and the information of the load.
  * @param {string} approval (string) is the response of the user could be true false or a custom response.
  */
  confirmDriver(data: ConfirmDriver, approval: string) {
    this.spinner.show();
    this.cargoItemService.confirmDrive(data, approval).subscribe(
      (success: Cargo) => {
        this.spinner.hide();
        this.belowSicetac(this.cargo, `cargo/detail/${this.cargo.consecutive}`);
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
        if (!this.utils.isEmpty(success.message)) {
          this.dialog.openDialog({
            title: success.message,
            iconError: true,
            hideBtnConfirm: true,
          }).then().catch(err => err);
        } else {
          this.snackBarService.openSnackBar("Confirmación realizada correctamente");
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        if (
          !this.utils.isEmpty(error) &&
          !this.utils.isEmpty(error.error) &&
          !this.utils.isEmpty(error.error.message)
        ) {
          this.snackBarService.openSnackBar(
            error.error.message,
            undefined,
            "alert"
          );
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error al realizar la confirmación",
            undefined,
            "error"
          );
        }
      }
    );
  }

  async openModalAssignSecondDriver() {
    const formControl = new FormControl();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Asignación de segundo conductor',
      label: 'Ingresa el número de documento',
      idVehicle: this.cargo.licensePlate,
      options: {
        typeUser: 'driver',
      },
      inputFormControl: formControl,
      linkDriverWithoutVehicle: true
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const result: { state: boolean, data: User } = await this.matDialog.open(ChangeDriverComponent, dialogConfig).afterClosed().toPromise();
    if (result && result.state && result.data && result.data.information && result.data.information.document)
      this.assignChangeDriver(result.data.information.document, this.cargo.id)
  }

  assignChangeDriver(document: string, cargoId: string) {
    const assignChangeDriverObserver = {
      next: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.ASSIGN_DRIVER_SUCCESS, 'asignado'));
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    };
    this.spinner.show();
    this.driverCargoService.changeAssignSecondDriver(`&driverDocument=${document}`, cargoId).subscribe(assignChangeDriverObserver);
  }
  /**
  * This method consumes the service that verifies if the owner of the vehicle have active receivables and sended the alert to the confirm driver method.
  */
  validateReceivables() {
    const observerListReceivables = {
      next: (data) => {
        if (data && data.some(receivable => receivable.state && receivable.state.description && receivable.state.description === 'pending')) {
          this.pendingReceivables = `El tenedor de este vehiculo ( ${this.vehicle.bankAccountBalance.name} ) tiene carteras pendientes. ¿Está seguro que desea confirmar la placa ${this.cargo.licensePlate} como vehiculo para el servicio ${this.cargo.consecutive}?`;
        } else {
          this.pendingReceivables = "";
        }
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
      },
      complete: () => {
        this.dialogConfirmDriver();
        this.spinner.hide();
      }
    };
    if (this.isSatelliteLockService) return this.dialogConfirmSatelliteLock();
    if (this.vehicle && this.vehicle.bankAccountBalance && this.vehicle.bankAccountBalance.document) {
      this.spinner.show();
      this.receivableService.getReceivableList(null, null, this.vehicle.bankAccountBalance.document).subscribe(observerListReceivables);
    } else {
      this.pendingReceivables = "";
      this.dialogConfirmDriver();
    }
  }
  /**
  * This method validates if the user could start the service.
  */
  async startServiceDialog() {
    const dateLoad = DateManager.setStartOfDay(DateManager.stringToDate(this.cargo.dateLoad));
    const today = DateManager.setStartOfDay(new Date());
    const permissionIgnoreDate = this.permissionRole.hasPermission(
      Permission.cargo.module,
      Permission.cargo.changeCargoLoadDate
    );
    let daysUntilLoad = DateManager.dateDiff(dateLoad, null, today);
    if (daysUntilLoad !== 0 && !permissionIgnoreDate)
      return this.snackBarService.openSnackBar(`Es demasiado ${daysUntilLoad > 0 ? 'pronto' : 'tarde'} para iniciar el servicio`, undefined, "error");
    // Iniciar
    if (this.companyManager.getOnlyDriverByCompanyNit(this.cargo.idCompany))
      this.getDetailDriver();
    else {
      this.dialog.openDialog({
        title:
          "Upss esta compañia esta restringida para simular las accciones del Conductor",
        iconError: true,
        hideBtnConfirm: true,
      }).then().catch(err => err);
    }
  }

  async checkConfirmStartService() {
    const { canContinue } = await this.checkCargoValidToContinue(!this.cargo.ministry);
    if (!canContinue) return;
    if (this.authService && this.cargo.ministry) {
      const { canContinue: canContinueConsignments } = await this.checkConsignmentErrors();
      if (!canContinueConsignments) return;
    }
    if (this.isSatelliteLockService) {
      if (!this.cargo.lock || !this.cargo.lock.imei)
        return this.snackBarService.openSnackBar("No se ha asignado un candado satelital al servicio", undefined, 'error');
      let matchLoads = await this.getLoadingRoutesByParameters('imeiLock', this.cargo.lock.imei);
      if (matchLoads && matchLoads.length) {
        let enableSimultaneousInrouteLoading = this.permissionRole.hasPermission(Permission.cargo.module, Permission.cargo.enableSimultaneousInrouteLoading);
        if (enableSimultaneousInrouteLoading)
          this.dialogMessage(`¿Estas seguro que deseas iniciar el servicio con el candado satelital ${this.cargo.lock.imei}?`, `<p class="ml-4"><i class="text-strong text-warning fas fa-exclamation-triangle mr-2"></i>Recuerda que este candado satelital tiene ${matchLoads.length} servicios en curso.</p>`, false, false, true, this.startService.bind(this));
        else
          this.dialogMessage('No es posible iniciar el servicio porque el candado satelital asignado ya tiene un servicio en curso', `<p class="ml-4">Por favor vuelva a intentarlo cuando el candado satelital ${this.cargo.lock.imei} finalice la ruta.</p>`, true, true);
        return;
      }
      this.startService();
      return;
    }
    if (!this.cargo || !this.cargo.licensePlate) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error')
      return;
    }
    if (this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.alertValidGps)) {
      const validGps = await this.validateVehicleGPS();
      if (!validGps) return;
    }
    let matchLoads = await this.getLoadingRoutesByParameters('licensePlate', this.cargo.licensePlate);
    if (!matchLoads || !matchLoads.length) {
      this.confirmStartService();
      return;
    }
    let enableSimultaneousInrouteLoading = this.permissionRole.hasPermission(Permission.cargo.module, Permission.cargo.enableSimultaneousInrouteLoading);
    if (enableSimultaneousInrouteLoading)
      this.dialogMessage(`¿Estas seguro que deseas iniciar el servicio con el vehículo ${this.cargo.licensePlate}?`, `<p class="ml-4"><i class="text-strong text-warning fas fa-exclamation-triangle mr-2"></i>Recuerda que este vehículo tiene ${matchLoads.length} servicios en curso.</p>`, false, false, true, this.confirmStartService.bind(this));
    else
      this.dialogMessage('No es posible iniciar el servicio porque el vehículo asignado ya tiene un servicio en curso', `<p class="ml-4">Por favor vuelva a intentarlo cuando el vehículo ${this.cargo.licensePlate} finalice la ruta.</p>`, true, true);
  }

  private async checkConsignmentErrors(): Promise<{ canContinue: boolean }> {
    this.spinner.show();
    try {
      const cargoConsignments = await this.cargoDetailService.getConsignments(this.cargo.id, 'Created');
      if (!cargoConsignments) {
        this.cargoDetailService.dialogConsignmentAlerts({ "No hay remesas asociadas al servicio": "Se requiere asociar al menos una remesa para iniciar el servicio" }, 'automatic');
        return { canContinue: false };
      }
      const { cargoConsignmentsAlerts } = this.cargoDetailService.updateConsignmentFieldsAndAlerts(this.cargo, cargoConsignments);
      if (cargoConsignmentsAlerts && Object.keys(cargoConsignmentsAlerts).length > 0 && Object.keys(cargoConsignmentsAlerts).some(consignmentKey => cargoConsignmentsAlerts[consignmentKey] !== null)) {
        this.cargoDetailService.dialogConsignmentAlerts(cargoConsignmentsAlerts, 'automatic');
        return { canContinue: false };
      }
      return { canContinue: true };
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      return { canContinue: false };
    } finally {
      this.spinner.hide();
    }
  }

  /**
  * This method allows to confirm the start of the load taking into account different conditions.
  */
  confirmStartService() {
    if (this.isSatelliteLockService) this.startServiceDialog();
    else if (this.allowCreatingWithoutTruora || (FIELDS_SECURITY_STUDY[Roles.DRIVER] && !FIELDS_SECURITY_STUDY[Roles.DRIVER].includes('truora')))
      this.startServiceDialog();
    else if (FIELDS_STATE[Roles.DRIVER] && (FIELDS_STATE[Roles.DRIVER].includes('arl') || FIELDS_STATE[Roles.DRIVER].includes('eps')))
      this.validateArlAndEPS();
    else if (FIELDS_STATE[Roles.DRIVER] && FIELDS_STATE[Roles.DRIVER].includes('operationalAccreditation'))
      this.validateAdditionalCertifications();
    else this.validateSOATandRTM();
  }

  /**
 * This method consumes a service that bring the loads in route sending one parameter.
 */
  async getLoadingRoutesByParameters(parameter: string, value: string, pagekey: number = 1, pageSize: number = 10): Promise<Cargo[]> {
    try {
      this.spinner.show();
      const response = await this.cargoListService.getListCargo(`&${parameter}=${value}&state=Start service`, pagekey, pageSize).toPromise();
      return response.results;
    } catch (error) {
      return [];
    } finally {
      this.spinner.hide();
    }
  }

  /**
 * This method checks if the vehicle's gps is valid to proceed
 */
  async validateVehicleGPS(): Promise<boolean> {
    this.spinner.show();
    const currentVehicle = await this.vehiclesService.getVehicleFromOwnCompany(this.cargo.licensePlate).toPromise();
    this.spinner.hide();
    if (!currentVehicle || !currentVehicle.id) {
      this.snackBarService.openSnackBar("No fue posible acceder al vehículo asignado", undefined, 'error');
      return false;
    }
    const form = new FormGroup({
      gpsType: new FormControl('', Validators.required),
      userGps: new FormControl(),
      passwordGps: new FormControl(),
      isPortableUnit: new FormControl(false),
      gpsId: new FormControl(),
    });

    if (currentVehicle.gps) {
      form.patchValue({
        gpsType: currentVehicle.gps.gpsType || '',
        userGps: currentVehicle.gps.userGps || '',
        passwordGps: currentVehicle.gps.passwordGps || '',
        isPortableUnit: !!currentVehicle.gps.isPortableUnit,
        gpsId: currentVehicle.gps.gpsId || ''
      });
      let valid: boolean = await this.vehicleManager.openGpsCargo(currentVehicle, form, this.cargo);
      if (valid) return true;
    }

    this.snackBarService.openSnackBar("Se requiere un GPS válido para iniciar el servicio", undefined, 'error');
    return false;
  }
  /**
  * This method opens a dialog that show a message to the user could be a error or a confirm message.
  */
  dialogMessage(message: string, descriptionHTML?: string, iconError: boolean = false, hideBtnConfirm: boolean = false, confirmAction: boolean = false, confirmActionMethod?: () => void) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: message,
      descriptionHTML,
      iconError,
      hideBtnConfirm
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    if (confirmAction) {
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.state) confirmActionMethod();
      });
    }
  }

  async validateArlAndEPS() {
    const notifications = [];
    try {
      const expiredDocuments: ExpiredDocuments[] | string = await this.getStateDriver(this.cargo.driver);
      if (typeof expiredDocuments === 'string') {
        if (expiredDocuments === UserMessages.DOCUMENT_NO_EXPIRATION)
          return this.snackBarService.openSnackBar(expiredDocuments, undefined, 'error');
        else
          return this.validateAdditionalCertifications();
      }
      expiredDocuments.forEach(document => {
        if (document && document.novelty && document.type && FIELDS_STATE[Roles.DRIVER] && FIELDS_STATE[Roles.DRIVER].includes(document.type.toLowerCase())) {
          if (document.novelty === 'outDated') notifications.push(Fmt.string(UserMessages.DOCUMENT_INSUFFICIENT_VALIDITY, document.type));
          else if (document.novelty === 'expired') notifications.push(Fmt.string(UserMessages.DOCUMENT_EXPIRATED, document.type));
          else if (document.novelty === 'approvalByMissed') notifications.push(Fmt.string(UserMessages.DOCUMENT_PENDING_APPROVAL, document.type));
          else if (document.novelty === 'securityStudyInProgress') notifications.push(Fmt.string(UserMessages.DOCUMENT_SECURITY_STUDY_IN_PROGRESS, document.type));
        }
      });
      if (!notifications.length)
        return this.validateAdditionalCertifications();

      let descriptionHTML: string = `
          El conductor del vehículo ${this.cargo.licensePlate} presenta alguna novedad en la documentación obligatoria: <br>
      <ol>${notifications.map(notification => `<li><i class="text-strong text-warning fas fa-exclamation-triangle"></i>${notification}</li>`).join('')}</ol><br>
        `;
      let allowStartService = expiredDocuments.every(document => {
        return (document && document.type === 'ARL' && this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.startServiceWithArlExpired))
          || (document && document.type === 'EPS' && this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.startServiceWithEpsExpired))
      })
      if (allowStartService) descriptionHTML = descriptionHTML + '<p class="text-center title-component" style="color:#495356">¿Desea continuar?</p>';
      this.newsOnMandatoryDocuments('Novedades en documentos del conductor', allowStartService, descriptionHTML, this.validateAdditionalCertifications.bind(this));

    } catch (error) {
      this.validateAdditionalCertifications();
    }
  }
  async validateAdditionalCertifications() {
    const notifications = [];
    const requiredCertifications: AdditionalCertificationEnum[] = [];

    if (FIELDS_STATE[Roles.DRIVER] && FIELDS_STATE[Roles.DRIVER].includes('operationalAccreditation'))
      requiredCertifications.push(AdditionalCertificationEnum.OPERATIONAL_ACCREDITATION);

    if (!requiredCertifications.length)
      return this.validateSOATandRTM();

    let userCertifications: AdditionalCertification[] = [];
    try {
      userCertifications = await this.adminUserService.getUserAdditionalCertifications(this.cargo.driver).toPromise();
    } catch (e) {
      userCertifications = [];
    }
    if (userCertifications && userCertifications.length)
      requiredCertifications.forEach(type => {
        const certification = userCertifications.find(cert => cert && cert.id === type);
        if (!certification)
          notifications.push(`${UserMessages.DOCUMENT_INACTIVE}, Se requiere el certificado de ${AdditionalCertificationDict[type]}`);
        else if (this.adminUserService.isExpiredAdditionalCertification(certification))
          notifications.push(Fmt.string(UserMessages.DOCUMENT_EXPIRATED, `certificación de ${AdditionalCertificationDict[type]}`));
        else if (!certification.approvalBy || !certification.approvalBy.userId)
          notifications.push(Fmt.string(UserMessages.DOCUMENT_PENDING_APPROVAL, `certificación de ${AdditionalCertificationDict[type]}`));
      })
    else
      notifications.push(`${UserMessages.DOCUMENT_INACTIVE}, Se requieren los certificados de ${requiredCertifications.map(cert => AdditionalCertificationDict[cert]).join(', ')}`);

    if (!notifications.length) {
      this.validateSOATandRTM();
      return;
    }
    let descriptionHTML: string = `
      El ${this.isEscortedService ? 'escolta con vehículo' : 'conductor del vehículo'} ${this.cargo.licensePlate} presenta alguna novedad en las certificaciones adicionales obligatorias: <br>
      <ol>${notifications.map(notification => `<li><i class="text-strong text-warning fas fa-exclamation-triangle"></i>${notification}</li>`).join('')}</ol><br>`;
    let allowStartService = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.startServiceWithAdditionalCertificationsInvalid);
    if (allowStartService) descriptionHTML = descriptionHTML + '<p class="text-center title-component" style="color:#495356">¿Desea continuar?</p>';
    this.newsOnMandatoryDocuments('Novedades en certificados adicionales', allowStartService, descriptionHTML, this.validateSOATandRTM.bind(this));
  }

  async validateSOATandRTM() {
    let lastTravelPointDate = new Date();
    for (const i in this.cargo.cargoFeature.uploadDownload.destination) {
      const destination = this.cargo.cargoFeature.uploadDownload.destination[i];
      if (
        this.utils.isDefined(destination.downloadDate) &&
        typeof destination.downloadDate === "string" &&
        destination.downloadDate.length > 9
      ) {
        const arrival = DateManager.stringToDate(destination.downloadDate);
        if (DateManager.isBefore(lastTravelPointDate, arrival, 'days')) lastTravelPointDate = arrival;
      } else {
        this.snackBarService.openSnackBar(
          `No hay registrada fecha de llegada al destino #${parseInt(i) + 1
          }`,
          undefined,
          "error"
        );
      }
    }
    let cargoCompany: Company = this.cargo.holderCompany
      ? await this.accountService.validateEntity(2, this.cargo.holderCompany).toPromise()
      : this.authService && this.authService.getUserSession() && this.authService.getUserSession().clientCompanyId
        ? await this.accountService.validateEntity(2, this.authService.getUserSession().clientCompanyId).toPromise()
        : null;
    const $validateExpirationRTMSOAT =
      this.vehiclesService.validateExpirationRTMSOAT(
        this.cargo.licensePlate,
        lastTravelPointDate,
        cargoCompany
      );
    const notifications = [];
    $validateExpirationRTMSOAT.subscribe({
      next: (result: VehicleMessages) => {
        notifications.push(result);
      },
      complete: () => {
        const permissionSpecialLicensePlate = this.permissionRole.hasPermission(
          this.permission.cargo.module,
          this.permission.cargo.specialLicensePlate
        );
        if (
          ((((notifications.includes(VehicleMessages.SOAT_MORE_N_DAYS) || notifications.includes(VehicleMessages.SOAT_VALID))
            && !notifications.includes(VehicleMessages.SOAT_INSURANCE_COMPANY_REQUIRED)
            && !notifications.includes(VehicleMessages.SOAT_POLICY_NUMBER_REQUIRED)) &&
            (notifications.includes(VehicleMessages.RTM_MORE_N_DAYS) || notifications.includes(VehicleMessages.RTM_EXONERATED) || notifications.includes(VehicleMessages.RTM_VALID))) ||
            (permissionSpecialLicensePlate && this.cargo.licensePlate === "C0N111") || this.allowCreatingWithoutTruora)
        ) {
          this.startServiceDialog();
        } else {
          let notificationsHtml = ``;

          const iconsStates = {
            danger: [
              VehicleMessages.RTM_NO_INFORMATION,
              VehicleMessages.RTM_NO_EXPIRATION,
              VehicleMessages.RTM_LESS_BLOCK_N_DAYS,
              VehicleMessages.RTM_EXPIRATED,
              VehicleMessages.RTM_EXPIRED_NOW,

              VehicleMessages.SOAT_NO_INFORMATION,
              VehicleMessages.SOAT_NO_EXPIRATION,
              VehicleMessages.SOAT_LESS_BLOCK_N_DAYS,
              VehicleMessages.SOAT_EXPIRATED,
              VehicleMessages.SOAT_EXPIRED_NOW,
              VehicleMessages.SOAT_INSURANCE_COMPANY_REQUIRED,
              VehicleMessages.SOAT_POLICY_NUMBER_REQUIRED,
            ],
            warning: [
              VehicleMessages.RTM_LESS_ALERT_N_DAYS,
              VehicleMessages.RTM_POSSIBLE_EXONERATED,
              VehicleMessages.SOAT_LESS_ALERT_N_DAYS,
            ],
            success: [
              VehicleMessages.RTM_MORE_N_DAYS,
              VehicleMessages.RTM_VALID,
              VehicleMessages.RTM_EXONERATED,

              VehicleMessages.SOAT_MORE_N_DAYS,
              VehicleMessages.SOAT_VALID,
            ],
          };

          const RtmSoatMessagesMap = {
            [VehicleMessages.RTM_MORE_N_DAYS]: Fmt.string(
              VehicleMessages.RTM_MORE_N_DAYS, cargoCompany && cargoCompany.daysToAlertExpirationRTM ? cargoCompany.daysToAlertExpirationRTM : VehicleMessages.DAYS_TO_ALERT_EXPIRATION_DEFAULT
            ),
            [VehicleMessages.RTM_LESS_ALERT_N_DAYS]: Fmt.string(
              VehicleMessages.RTM_LESS_ALERT_N_DAYS, cargoCompany && cargoCompany.daysToAlertExpirationRTM ? cargoCompany.daysToAlertExpirationRTM : VehicleMessages.DAYS_TO_ALERT_EXPIRATION_DEFAULT
            ),
            [VehicleMessages.RTM_LESS_BLOCK_N_DAYS]: Fmt.string(
              VehicleMessages.RTM_LESS_ALERT_N_DAYS, cargoCompany && cargoCompany.daysToBlockRTM ? cargoCompany.daysToBlockRTM : VehicleMessages.DAYS_TO_BLOCK_DEFAULT
            ),
            [VehicleMessages.SOAT_MORE_N_DAYS]: Fmt.string(
              VehicleMessages.SOAT_MORE_N_DAYS, cargoCompany && cargoCompany.daysToAlertExpirationSOAT ? cargoCompany.daysToAlertExpirationSOAT : VehicleMessages.DAYS_TO_ALERT_EXPIRATION_DEFAULT
            ),
            [VehicleMessages.SOAT_LESS_ALERT_N_DAYS]: Fmt.string(
              VehicleMessages.SOAT_LESS_ALERT_N_DAYS, cargoCompany && cargoCompany.daysToAlertExpirationSOAT ? cargoCompany.daysToAlertExpirationSOAT : VehicleMessages.DAYS_TO_ALERT_EXPIRATION_DEFAULT
            ),
            [VehicleMessages.SOAT_LESS_BLOCK_N_DAYS]: Fmt.string(
              VehicleMessages.SOAT_LESS_ALERT_N_DAYS, cargoCompany && cargoCompany.daysToBlockSOAT ? cargoCompany.daysToBlockSOAT : VehicleMessages.DAYS_TO_BLOCK_DEFAULT
            )
          }

          for (const i in notifications) {
            notificationsHtml = `${notificationsHtml}
              <li>
                ${iconsStates.danger.includes(notifications[i]) ? `<i class="text-strong text-danger fas fa-exclamation-circle"></i>` : ""}
                ${iconsStates.warning.includes(notifications[i]) ? `<i class="text-strong text-warning fas fa-exclamation-triangle"></i>` : ""}
                ${iconsStates.success.includes(notifications[i]) ? `<i class="text-strong text-success fas fa-check-circle"></i>` : ""}
                ${RtmSoatMessagesMap[notifications[i]] ? RtmSoatMessagesMap[notifications[i]] : notifications[i]}
              </li>`;
          }
          let descriptionHTML: string = `
            El vehículo con placas ${this.cargo.licensePlate} presenta alguna novedad en la documentación obligatoria: <br>
              <ol>${notificationsHtml}</ol> <br>
            `;
          let allowStartService = false;
          let error = '';
          if (notifications.includes(VehicleMessages.SOAT_INSURANCE_COMPANY_REQUIRED) || notifications.includes(VehicleMessages.SOAT_POLICY_NUMBER_REQUIRED)) {
            error = "El vehículo no tiene una compañía de seguro válida o un número de poliza válido";
          }
          else if (notifications.includes(VehicleMessages.SOAT_EXPIRATED) || notifications.includes(VehicleMessages.RTM_EXPIRATED)
            || notifications.includes(VehicleMessages.RTM_EXPIRED_NOW) || notifications.includes(VehicleMessages.SOAT_EXPIRED_NOW)) {
            error = "Un vehículo sin documentación obligatoria no puede circular";
            if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.useCarWithExpiredDocuments)) allowStartService = true;
          } else if (notifications.includes(VehicleMessages.SOAT_LESS_BLOCK_N_DAYS) || notifications.includes(VehicleMessages.RTM_LESS_BLOCK_N_DAYS) ||
            notifications.includes(VehicleMessages.RTM_POSSIBLE_EXONERATED)) {
            if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.useCarNearExpirationDocuments)) {
              allowStartService = true;
            } else if (notifications.includes(VehicleMessages.RTM_POSSIBLE_EXONERATED)) {
              error = "El vehículo está en su último año de exoneración de RTM, Solicite la asignación a seguridad";
            } else if (notifications.includes(VehicleMessages.SOAT_LESS_BLOCK_N_DAYS)) {
              error = `El SOAT del vehículo tiene vigencia inferior a ${cargoCompany && cargoCompany.daysToBlockSOAT ? cargoCompany.daysToBlockSOAT : VehicleMessages.DAYS_TO_BLOCK_DEFAULT} días, solicite la asignación a seguridad`;
            } else {
              error = `La RTM del vehículo tiene vigencia inferior a ${cargoCompany && cargoCompany.daysToBlockRTM ? cargoCompany.daysToBlockRTM : VehicleMessages.DAYS_TO_BLOCK_DEFAULT} días, solicite la asignación a seguridad`;
            }
          } else if (notifications.includes(VehicleMessages.SOAT_LESS_ALERT_N_DAYS) || notifications.includes(VehicleMessages.RTM_LESS_ALERT_N_DAYS)) {
            error = "Los documentos del vehículo están próximos a vencer";
            allowStartService = true;
          } else {
            error = "Ha ocurrido un error con la validación de documentos obligatorios";
          }
          if (error) {
            descriptionHTML = descriptionHTML + `<div class="alert alert-${allowStartService ? 'warning' : 'danger'} mt-2 d-flex flex-row align-items-center justify-content-center" role="alert"><i class="fas fa-exclamation-triangle fa-lg mr-3"></i> <span class="text-bold">${error}</span></div>`
          }
          if (allowStartService) {
            descriptionHTML = descriptionHTML + '<p class="text-center title-component">¿Desea continuar?</p>';
          }
          this.newsOnMandatoryDocuments('Novedades en documentos obligatorios', allowStartService, descriptionHTML, this.startService.bind(this));
        }
      },
    });
  }
  /**
  * This method checkif the vehicle of the user have news in the mandatory documents.
  */
  newsOnMandatoryDocuments(title: string, allowStartService: boolean, descriptionHTML: string, funct: Function) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title,
      descriptionHTML,
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    if (!allowStartService) {
      dialogConfig.data['hideBtnConfirm'] = true;
    }
    this.matDialog.open(DialogComponent, dialogConfig).afterClosed().subscribe((result) => {
      if (result && result.state && allowStartService)
        funct();
    });
  }

  /**
  * This method check the state of arl and eps of the driver
  */
  async getStateDriver(document: string): Promise<ExpiredDocuments[] | string> {
    return new Promise((resolve, reject) => {
      const userObserver = {
        next: (user: User) => {
          this.spinner.hide();
          let expiredDocuments: ExpiredDocuments[] = [];
          let types = ['ARL', 'EPS'];
          if (user && user.extraDocuments && user.extraDocuments.length && user.extraDocuments.some(document => types.includes(document.type))) {
            const currentDate = new Date();
            const estimatedDate = DateManager.add(currentDate, this.cargo.estimatedTime, "seconds");
            const lastAddress = DateManager.stringToDate(this.cargo.cargoFeature.uploadDownload.destination[this.cargo.cargoFeature.uploadDownload.destination.length - 1].downloadDate);
            expiredDocuments = user.extraDocuments.filter(document => {
              if (document.type && document.dueDate && types.includes(document.type)) {
                let docState = this.adminUserService[`get${document.type.toLowerCase()}State`](user);
                if (docState === 'Activo') return false;
                if (docState === 'Estudio de seguridad en proceso') {
                  document.novelty = 'securityStudyInProgress';
                  return true;
                }
                const dueDate = DateManager.stringToDate(document.dueDate);
                if (!document.approvalBy) {
                  document.novelty = 'approvalByMissed';
                  return true;
                }
                else if (DateManager.isBefore(dueDate, currentDate)) {
                  document.novelty = 'expired';
                  return true;
                }
                else if (DateManager.isBefore(dueDate, estimatedDate) || DateManager.isBefore(dueDate, lastAddress)) {
                  document.novelty = 'outDated';
                  return true;
                }
              }
              return false;
            });
          }

          if (user && types.some(type => user[type.toLowerCase()] && !user[type.toLowerCase()].active)) {
            types.forEach(type => {
              if (user[type.toLowerCase()] && !user[type.toLowerCase()].active && expiredDocuments && !expiredDocuments.some(document => document.type === type)) expiredDocuments.push({ type, novelty: 'expired' })
            })
          }
          if (expiredDocuments && expiredDocuments.length) resolve(expiredDocuments);
          else if (this.adminUserService.getTruoraInProgress(user)) {
            expiredDocuments.push({ type: 'ARL', novelty: 'securityStudyInProgress' });
            expiredDocuments.push({ type: 'EPS', novelty: 'securityStudyInProgress' });
            resolve(expiredDocuments);
          }
          else reject(UserMessages.DOCUMENT_ACTIVE);
        },
        error: () => {
          this.spinner.hide();
          reject(UserMessages.DOCUMENT_NO_EXPIRATION);
        }
      };
      this.spinner.show();
      this.adminUserService.getUsersDetailByDocument(document).subscribe(userObserver);
    });
  }

  daysToLoadService(): number {
    if (!this.cargo || !this.cargo.dateLoad) return 0;
    const permissionIgnoreDate = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.changeCargoLoadDate);
    if (permissionIgnoreDate) return 0;
    return DateManager.dateDiff(DateManager.transformDateUFC(this.cargo.dateLoad));
  }

  startService() {
    if (CargoOptionsComponent.GpsProviders === null) {
      CargoOptionsComponent.GpsProviders = {};
      this.cargoOptionsService.getGPSProviders().subscribe(
        (gpsProviders: Array<{ monitor: boolean, name: string, companyId: string, id: string }>) => {
          // Por seguridad salimos de las llamadas http setteando GpsProviders
          if (!!gpsProviders && Array.isArray(gpsProviders)) {
            gpsProviders.forEach(
              (gps) => {
                if (!environment.ignoredGPSByMonitor.includes(gps.name))
                  CargoOptionsComponent.GpsProviders[gps.name] = gps;
              }
            );

            this.checkMonitorOrStartService();
          }
        },
        (err) => {
          // Por seguridad salimos de las llamadas http setteando GpsProviders
          this.snackBarService
            .openSnackBar(
              "Ocurrió un error cargando los proveedores GPS habilitados",
              "x",
              "error"
            );
        }
      );
    } else {
      this.checkMonitorOrStartService();
    }
  }

  /**
  * @param {string} licensePlate is the license plate of the vehicle starting the service
  * @returns {Promise<boolean>} true when the vehicle has a GPS of a Satrack provider but no link recorded
  * @description Only informs the user: the backend reconciles the link on its own when the service starts,
  * so a failed check resolves to false instead of bothering anyone
  */
  private checkUnlinkedSatrackGps(licensePlate: string): Promise<boolean> {
    if (!licensePlate) return Promise.resolve(false);
    return this.vehiclesService.getVehicleFromOwnCompany(licensePlate).pipe(
      switchMap((vehicle) => this.vehiclesService.hasUnlinkedSatrackGps(vehicle))
    ).toPromise().then((unlinked) => !!unlinked).catch(() => false);
  }

  checkMonitorOrStartService() {
    this
      .askForMonitorIfNecesary()
      .subscribe({
        next: () => {
          const data = {
            idCargo: this.cargo.id,
          };
          // Checked alongside the start, before the backend's reconciliation records a link, and never awaited by it
          const licensePlate = this.cargo.licensePlate;
          const unlinkedSatrackGps = this.checkUnlinkedSatrackGps(licensePlate);
          this.spinner.show();
          this.cargoEvidenceService.setStateAddressTracking(data, CargoStateEnum.START_SERVICE)

            .subscribe(
              () => {
                this.router.navigate(["cargo/tracking/", this.cargo.consecutive.toString()]);
                this.spinner.hide();
                unlinkedSatrackGps.then((unlinked) => {
                  if (unlinked)
                    this.snackBarService.openSnackBar(Fmt.string(ServiceMessages.SATRACK_GPS_LINK_INCONSISTENT, licensePlate), undefined, 'alert', 10000);
                });
              },
              async (error: HttpErrorResponse) => {
                this.spinner.hide();
                this.applyCargoFromRndcResponse(error);
                const shouldShowContingencyDialog = this.shouldShowManifestContingencyDialog(error);
                if (shouldShowContingencyDialog) return this.handleRndcManifestContingency();
                const backendMessage = getRndcRequestFailureDisplayMessage(error);
                const manifestError = error && error.error && (error.error as any).manifestError && (error.error as any).manifestError.error;
                let description = 'Ocurrió un error al intentar iniciar el servicio.';
                if (backendMessage && manifestError && !this.rndcContingencyActive)
                  description = `${backendMessage}\n${manifestError}`;
                else if (backendMessage)
                  description = backendMessage;
                else if (manifestError && !this.rndcContingencyActive)
                  description = manifestError;
                else if (this.cargo.ministry && !this.rndcContingencyActive && !this.cargo.manifestAuthorization)
                  description = 'Se requiere generar el manifiesto para iniciar el servicio.';
                const dialogConfig = new MatDialogConfig();
                dialogConfig.data = {
                  title: 'Error al iniciar el servicio',
                  iconError: true,
                  hideBtnConfirm: true,
                  description
                };
                dialogConfig.width = ModalEnum.SMALL_WIDTH;
                dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
                dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
                dialogConfig.autoFocus = false;

                this.matDialog.open(DialogComponent, dialogConfig).afterClosed().subscribe(() => {
                  this.refreshCargo.emit(this.cargo.consecutive);
                });
              }
            );
        },
        error: async (_error) => {
          this.spinner.hide();
          this.applyCargoFromRndcResponse(_error);
          const shouldShowContingencyDialog = this.shouldShowManifestContingencyDialog(_error);
          if (shouldShowContingencyDialog) return this.handleRndcManifestContingency();
          const displayMessage = getRndcRequestFailureDisplayMessage(_error);
          if (displayMessage) {
            this.snackBarService.openSnackBar(displayMessage, undefined, 'error');
            return;
          }
          console.error(_error);
        },
      });
  }

  private async handleRndcManifestContingency(): Promise<boolean> {
    this.spinner.hide();
    const rndcContingencyCopy = {
      title: 'RNDC Intermitente',
      message:
        'El RNDC presenta intermitencia y no es posible generar el manifiesto. '
        + 'Puede continuar sin la radicación, la cual se generará automáticamente al restablecerse el servicio, '
        + 'siempre y cuando no presente errores, o esperar a que el servicio se normalice '
        + 'para poder generar la documentación con el radicado.',
      warningMessage:
        'Al continuar sin generar el manifiesto, el proceso queda bajo responsabilidad de la empresa de transporte.',
    };
    const confirmed = await this.openContingencyDialog(rndcContingencyCopy).toPromise();
    if (!confirmed) return true;
    try {
      this.spinner.show();
      await this.cargoDetailService.authorizeCargoWithoutManifest(this.cargo.id).toPromise();
      await this.refreshCargo.emit(this.cargo.consecutive);
      this.spinner.hide();
      this.snackBarService.openSnackBar('Servicio autorizado bajo intermitencia RNDC sin manifiesto emitido.');
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  private shouldShowManifestContingencyDialog(responseOrError: unknown): boolean {
    return shouldShowRndcIntermittencyAuthorizationDialog(responseOrError, this.cargo);
  }

  private applyCargoFromRndcResponse(responseOrError: unknown): void {
    const mergedCargo = mergeCargoFromRndcResponse(this.cargo, responseOrError);
    if (mergedCargo) {
      this.cargo = mergedCargo;
    }
  }

  private openContingencyDialog(dialogCopy: {
    readonly title: string;
    readonly message: string;
    readonly warningMessage: string;
  }): Observable<boolean> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      title: dialogCopy.title,
      description: dialogCopy.message,
      descriptionHTML: `
        <div class="alert alert-warning m-3 d-flex align-items-center justify-content-center" role="alert">
          <i class="fas fa-exclamation-triangle mr-2"></i><span>${dialogCopy.warningMessage}</span>
        </div>
      `,
      iconAlert: true,
      labelButton1: 'Cancelar',
      labelButton2: 'Confirmar',
      hideBtnCancel: true,
      hideBtnConfirm: true,
      closeModal: true,
    };
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(
      map((result: { readonly state?: boolean; readonly refuse?: string } | undefined) =>
        !!(result && result.state && result.refuse === 'Confirmar')
      )
    );
  }

  getGpsProvider(gps: Gps) {
    const name = gps && gps.gpsType ? gps.gpsType.toUpperCase() : null;
    return name ? CargoOptionsComponent.GpsProviders[name] : null;
  }

  askForMonitorIfNecesary() {
    return new Observable<boolean>(
      observer => {
        // Fase 1 (rastreo satelital automático): si el cargo cumple las condiciones
        // (GPS Monitor + super permiso innovbo, o flag SaaS + config de empresa con Monitor),
        // se registra automáticamente sin diálogos. Si no aplica, se usa el flujo manual.
        this.satelliteTrackingService.autoRegisterIfApplicable(this.cargo, this.vehicle).subscribe({
          next: (registered) => {
            if (registered) {
              console.log('[RastreoSatelital] inicio de servicio: registrado automáticamente', this.cargo && this.cargo.id);
              this.snackBarService.openSnackBar("Vehículo registrado correctamente", "Aceptar", "success");
              observer.next(true);
              observer.complete();
              return;
            }
            console.log('[RastreoSatelital] inicio de servicio: no aplica auto-registro, flujo manual', this.cargo && this.cargo.id);
            this.runManualMonitorFlow(observer);
          },
          error: () => {
            // El registro automático aplicaba pero falló: se ofrece el flujo manual.
            this.runManualMonitorFlow(observer);
          }
        });
      }
    );
  }

  private runManualMonitorFlow(observer: Observer<boolean>) {
    const company = this.authService && this.authService.getCompany();
    if (this.vehicle && this.vehicle.gps && this.getGpsProvider(this.vehicle.gps)
      && this.getGpsProvider(this.vehicle.gps).monitor) {
      if (
        company &&
        company.gpsConfiguration &&
        company.gpsConfiguration.monitor &&
        company.gpsConfiguration.monitor.active
      ) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          title: `¿Deseas realizar la trazabilidad automática con GPS del vehículo ${this.vehicle.id}?`,
          description: `Recuerde que este servicio tiene costo adicional.`,
          showYesBtn: true,
          showNoBtn: true,
          hideBtnCancel: true
        };
        dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
        dialogConfig.autoFocus = false;
        dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
        dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
        const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
          if (result === undefined)
            return;

          const must_register_vehicle = result && result.state;
          if (must_register_vehicle) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = { licensePlate: this.vehicle.id, startDate: (new Date()).toISOString() };
            dialogConfig.width = ModalEnum.LARGE_WIDTH;
            dialogConfig.autoFocus = false;
            dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
            dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
            dialogConfig.disableClose = true;
            const dialogRef = this.matDialog.open(RequestDatesToMonitorComponent, dialogConfig);
            dialogRef
              .afterClosed()
              .subscribe(
                (result: { state: 'goBack' | 'confirm', dates: { start: string | null, end: string | null } }) => {
                  if (result.state === 'goBack') {
                    this.startService();
                    observer.complete();
                  } else {
                    this.cargoService
                      .registerVehicleInMonitor(this.cargo.id, result.dates.start, result.dates.end)
                      .subscribe({
                        next: (response) => {
                          this.snackBarService.openSnackBar("Vehículo registrado correctamente", "Aceptar", "success");
                          observer.next(true);
                        },
                        error:
                          observer.error,
                        complete:
                          observer.complete
                      });
                  }
                },
                observer.error
              );
          } else {
            observer.next(false);
            observer.complete();
          }
        });
      } else {
        // Tiene monitor deshabilitado pero el soporta el GPS
        if (this.permissionRole.hasPermission(Permission.administration.module, Permission.administration.setupMonitorIntegration)) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            title: `Configurar trazabilidad`,
            description: `
                  Puede activar la trazabilidad GPS automática
                  para mejorar la seguridad de este servicio,
                  recuerde que tiene costo adicional por uso.
                  ¿Quiere configurarla ahora?`,
            showYesBtn: true,
            showNoBtn: true,
            hideBtnCancel: true
          };
          dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
          dialogConfig.autoFocus = false;
          dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
          dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
          const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(
            (result) => {
              if (result && result.state) {
                observer.error(null);
                observer.complete();
                this.router.navigate(['administration/companies/detail', company.companyId]);
              } else {
                observer.next(false);
                observer.complete();
              }

            }
          );
        } else {
          observer.next(false);
          observer.complete();
        }
      }
    } else {
      observer.next(false);
      observer.complete();
    }
  }
  /**
  * This method set the state tracking of the first address in this case de first address of the origin.
  */
  setStatusFirstAddress() {
    const data = {
      idCargo: this.cargo.id,
      addressId: this.cargo.cargoFeature.uploadDownload.origin.addresses[0].id,
      address:
        this.cargo.cargoFeature.uploadDownload.origin.addresses[0].address,
      type: "Origin",
    };

    this.cargoEvidenceService
      .setStateAddressTracking(data, "Arrived to pickup cargo")
      .subscribe(
        (success) => {
          //this.spinner.hide();
          //this.router.navigate(['cargo/tracking/', this.cargo.id]);
        },
        (error) => {
          //this.spinner.hide();
        }
      );
  }

  /*private validateLicenseExpirationDate(driver): boolean {
    let isExpired: boolean = false;
    if (driver.driverLicenseCategory) {
      driver.driverLicenseCategory.map((data) => {
        let diff = this.dateManager.dateDiff(new Date(),null,data.expirationDate,null,'minutes');
        if (diff >= 0 && !isExpired) {
          isExpired = true;
        }
      });
    } else {
      isExpired = true;
    }
    return isExpired;
  }*/
  /**
  * This method brings the information of the driver.
  */
  async getDetailDriver() {
    let driver: User;
    try { driver = await this.accountService.validateEntity(1, this.cargo.driver).toPromise(); } catch (error) { }
    if (!driver) {
      this.driver = { information: { document: this.cargo.driver } };
      this.showErrorByDriverStartService("No fue posible obtener la información del conductor");
      return;
    }
    this.driver = this.userManager.sanitizeUser(driver, Roles.DRIVER);
    this.getDetailVehicle();
  }
  /**
  * This method open a dialog that in this case is used to show errors related with the beginning of the load.
  * @param {string} title (string) is the text that would be contain in the dialog.
  */
  showErrorByDriverStartService(title: string) {
    this.dialog.openDialog({
      title,
      iconError: true,
      hideBtnConfirm: true,
    }).then().catch(err => err);
  }
  /**
  * This method open a dialog window that asks the user for the confirmation of the vehicle assigned.
  * @param {boolean} ignoreConfirmation (boolean) is a parameter that allows to ignore the confirmation dialog and open directly the inspection if is neccesary.
  */
  private async validateConfirmedDriver(ignoreConfirmation: boolean = false): Promise<void> {
    if (this.cargo.confirmedDriver === true) {
      const { active, errors } = await this.adminUsersService.isEnabledByValidationRules(this.driver, 'Driver');
      let documentsToValidate = errors
        .filter(error => /arl|eps/i.test(error))
        .map(error => error.toLowerCase().includes('arl') ? 'arl' : 'eps');
      if (
        active &&
        this.vehicle &&
        this.vehicle.state &&
        this.vehicle.state.active
      ) {
        if (!ignoreConfirmation) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            title: `¿Estás seguro que deseas iniciar este servicio?`,
          };
          dialogConfig.width = ModalEnum.SMALL_WIDTH;
          dialogConfig.autoFocus = false;
          dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
          dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
          const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(async (result) => {
            if (result && result.state) {
              const validGPS = await this.setCargoGPS();
              if (!validGPS) {
                this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
                return;
              }
              this.startService()
            }
          });
        } else {
          const validGPS = await this.setCargoGPS();
          if (!validGPS) {
            this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
            return;
          }
          this.startService()
        }
      } else {
        this.adminUserService.confirmDriverInactive(this.driver, this.vehicle, documentsToValidate);
      }
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: `La placa ${this.cargo.licensePlate} aún no se ha confirmado para iniciar este servicio`,
        iconError: true,
        hideBtnConfirm: true,
      };
      dialogConfig.width = ModalEnum.SMALL_WIDTH;
      dialogConfig.autoFocus = false;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      this.matDialog.open(DialogComponent, dialogConfig);
    }
    this.belowSicetac(this.cargo, `cargo/tracking/${this.cargo.consecutive}`);
  }

  private async setCargoGPS(): Promise<boolean> {
    let currentVehicle: Vehicle;
    try {
      currentVehicle = await this.vehiclesService.getVehicleFromOwnCompany(this.cargo.licensePlate).toPromise();
    } catch (e) {
      return false;
    }
    if (!currentVehicle) return false;
    if (!currentVehicle.gps || (currentVehicle.gps && !currentVehicle.gps.gpsId)) return true;
    const body = { ...this.cargo, gpsId: currentVehicle.gps.gpsId };
    delete body.shippingCost.payments;
    delete body.travelExpenses;
    delete body.validatedBankAccount;
    let response;
    try {
      response = await this.cargoService.updateFields(body).toPromise();
    } catch (e) {
      return false;
    }
    if (response) return true;
    return false;
  }

  /**
  * This method brings the information of the vehicle and the inspection respectively.
  * @returns {Observable<any>} (Observable<any>) returns the information of the vehicle
  */
  public loadVehicle(): Observable<any> {
    const $vehicle = new Observable((observer) => {
      this.vehiclesService.getVehicleFromOwnCompany(this.cargo.licensePlate).subscribe(
        async (success: any) => {
          if (!!success) {
            this.vehicle = success;
            observer.next("vehicle");
            if (this.cargo && this.cargo.vehicleInspection) {
              this.cargoItemService
                .getInspection(this.cargo.vehicleInspection, "vehicle")
                .subscribe(
                  (res: any) => {
                    observer.next("inspection");
                    this.lastInspection = res;
                    observer.complete();
                  },
                  (error) => observer.error(error)
                );
            } else observer.error('No se encontró la inspección preoperacional del vehículo');
          } else observer.error(`Failed to get vehicle`);
        },
        (error) => observer.error(error)
      );
    });
    return $vehicle;
  }

  public loadSatelliteLock(): Observable<any> {
    if (!this.cargo.lock || !this.cargo.lock.imei) return of(null);
    const $satelliteLock = new Observable((observer) => {
      this.satelliteLockService.getSatelliteLockByImei(this.cargo.lock.imei).subscribe(
        async (success: any) => {
          if (!!success) {
            this.satelliteLock = success;
            observer.next("satelliteLock");
            this.cargoDetailService.getSatelliteLockInspection(this.cargo.id).subscribe(
              (res: SatelliteLockInspection) => {
                observer.next("satelliteLockInspection");
                this.lastInspection = res;
                observer.complete();
              },
              (error) => observer.error(error)
            );
          } else observer.error(`Failed to get vehicle`);
        },
        (error) => observer.error(error)
      );
    });
    return $satelliteLock;
  }
  /**
  * This method brings the information of the vehicle.
  */
  public getDetailVehicle() {
    this.loadVehicle().subscribe(
      (loaded) => {
        if (loaded == "vehicle") {
          const validTrailer =
            (this.vehicle &&
              !this.utils.isEmpty(this.vehicle.trailerId) &&
              this.cargo.ministry &&
              this.cargo.cargoFeature &&
              this.cargo.cargoFeature.vehicleType &&
              this.vehicle.vehicleType &&
              this.vehicle.vehicleType.name.trim().toLowerCase() ===
              "TRACTOCAMION".trim().toLowerCase()) ||
            !this.cargo.ministry ||
            this.cargo.cargoFeature.vehicleType.name !== "TRACTOCAMION";
          if (validTrailer) {
            if (
              (this.cargoManager.getTypeCargo(this.cargo) == "Nacional" ||
                this.cargoManager.getTypeCargo(this.cargo) == "Internacional") &&
              this.lastInspection &&
              !this.lastInspection.approval
            ) {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.data = {
                title:
                  "Debes aprobar la inspección del vehiculo, antes de iniciar el servicio",
                hideBtnCancel: false.valueOf,
              };
              dialogConfig.width = ModalEnum.SMALL_WIDTH;
              dialogConfig.autoFocus = false;
              dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
              dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
              const dialogRef = this.matDialog.open(
                DialogComponent,
                dialogConfig
              );
              dialogRef.afterClosed().subscribe((result) => {
                if (result && result.state) {
                  this.showInspection.emit();
                }
              });
            } else if (
              this.utils.isEmpty(this.cargoManager.getTypeCargo(this.cargo)) ||
              this.cargoManager.getTypeCargo(this.cargo) === "Urbana"
            ) {
              this.validateConfirmedDriver();
            } else {
              let validData =
                this.vehicleManager.completeDriverLongMile(this.driver) &&
                this.vehicleManager.completeVehicleLongMile(this.vehicle);
              if (validData) {
                this.validateConfirmedDriver();
              } else {
                const missingFiels = this.vehicleManager.getMissingFiels(
                  this.vehicle,
                  this.driver
                );
                const dialogConfig = new MatDialogConfig();
                dialogConfig.data = {
                  title: "Los siguientes datos aún no se han registrado",
                  iconError: true,
                  hideBtnConfirm: true,
                  messageList: missingFiels,
                };
                dialogConfig.width = ModalEnum.SMALL_WIDTH;
                dialogConfig.autoFocus = false;
                dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
                dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
                const dialogRef = this.matDialog.open(
                  DialogComponent,
                  dialogConfig
                );
                dialogRef.afterClosed().subscribe((result) => {
                  const dialogConfig = new MatDialogConfig();
                  dialogConfig.data = {
                    title: "¿Desea continuar con el inicio del servicio?",
                    showYesBtn: true,
                    showNoBtn: true,
                    hideBtnCancel: false.valueOf,
                  };
                  dialogConfig.width = ModalEnum.SMALL_WIDTH;
                  dialogConfig.autoFocus = false;
                  dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
                  dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
                  const dialogRef = this.matDialog.open(
                    DialogComponent,
                    dialogConfig
                  );
                  dialogRef.afterClosed().subscribe((result) => {
                    if (result && result.state) {
                      this.validateConfirmedDriver(true);
                    } else {
                      this.openVehicle.emit();
                    }
                  });
                });
              }
            }
          } else {
            let titleDialog: string;
            if (!validTrailer) {
              titleDialog = `La placa ${this.cargo.licensePlate} aún no registra un Trailer asociado, debe registrar uno para poder iniciar el servicio`;
            }
            if (titleDialog) {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.data = {
                title: titleDialog,
                iconError: true,
                hideBtnConfirm: true,
              };
              dialogConfig.width = ModalEnum.SMALL_WIDTH;
              dialogConfig.autoFocus = false;
              dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
              dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
              const dialogRef = this.matDialog.open(
                DialogComponent,
                dialogConfig
              );
              dialogRef.afterClosed().subscribe((result) => {
                this.openVehicle.emit();
              });
            }
          }
        }
      },
      () => (this.vehicle = null)
    );
  }

  public findApplications() {
    this.router.navigate(['/cargo/applications', this.cargo.consecutive]);
  }
  /**
  * This method open a dialog window that allows the user to assign a vehicle to the load.
  */
  async openModalAssignVehicle() {
    const { canContinue } = await this.checkCargoValidToContinue();
    if (!canContinue) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Datos del Vehículo Asignado",
      cargo: this.cargo,
      type: 'assign'
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.matDialog.open(AssignVehicleCargoComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.refreshCargo.emit(this.cargo.consecutive);
        this.refreshListCargo.emit();
      }
    });
  }
  /**
  * This method open a dialog window that shows to the user the information of the person that assign the vehicle.
  */
  showAssignedVehicleData() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Datos del Vehículo Asignado",
      hideBtnCancel: true,
      messageList: [
        "Servicio: " + this.cargo.consecutive,
        "Confirmada por: " + this.cargo.confirmedDriverFingerprint.userName,
        "Fecha confirmación: " +
        this.dateFormatPipe.transform(
          this.cargo.confirmedDriverFingerprint.date,
          "only-date"
        ),
      ],
      icon: true,
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  get showBtnApproveCargo(): SelectableItem {
    return this.cargoListService.isCargoToApprove(this.cargo, 'approvePayments');
  }

  get showBtnDisapproveCargo(): SelectableItem {
    return this.cargoListService.isCargoToDisapprove(this.cargo, 'approvePayments');
  }

  public async openDialogApproveCargo(state: boolean): Promise<void> {
    let reason = '';
    if (state) {
      const totalValue = await this.balance();
      const { confirm } = await this.cargoManager.openDialogConfirm("Aprobar Servicio", `${this.titles.titlesModalApproveCargo} ${this.currencyPipe.transform(totalValue, "COP", "code")}?`);
      if (!confirm) return;
    }
    else {
      const { confirm, description } = await this.cargoManager.openDialogConfirmWithDescription("Rechazar Servicio", "Ingrese motivo por el que se rechaza el servicio", 200, 10);
      if (!confirm) return;
      reason = description;
    }
    const body = { cargoIds: [this.cargo.id], reason };
    this.spinner.show();
    this.cargoListService.approvedCargoBalance(body, state).subscribe({
      next: (result: Cargo[]) => {
        this.spinner.hide();
        if (result && result.length && result[0].approval === (state ? 'Approved' : 'Rejected'))
          this.snackBarService.openSnackBar(`Se ha ${state ? 'aprobado' : 'rechazado'} correctamente el servicio ${this.cargo.consecutive}`, undefined, "success");
        else this.snackBarService.openSnackBar(`Ocurrió un error al ${state ? 'aprobar' : 'rechazar'} el servicio ${this.cargo.consecutive}`, undefined, "error");
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      },
      error: (error) => {
        this.spinner.hide();
        if (error.error)
          this.snackBarService.openSnackBar(error.error, undefined, "error");
        else
          this.snackBarService.openSnackBar(error, undefined, "error");
      }
    });
  }

  get hasBalanceAndIsPaid(): boolean {
    return this.utils.getNestedValue(this.cargo, 'shippingCost.balanceState')
      && this.cargoItemService.getCargoBalancePaid(this.cargo) > 0;
  }

  get showBtnModificationsShippingCost(): { show: boolean, canModify?: boolean, error?: string } {
    if (!this.cargo) return { show: false };
    if ([CargoStateEnum.DELETED, CargoStateEnum.EXPIRED, CargoStateEnum.REQUEST].includes(this.cargo.state))
      return { show: false };
    const basicPermission = this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.modifyShippingCost
    );
    const fullAccessPermission = this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.changeRateFullAccess
    );
    if (!basicPermission) return { show: false };
    const isPaid = this.utils.getNestedValue(this.cargo, 'shippingCost.paid');
    const isValidated = this.utils.getNestedValue(this.cargo, 'prevalidation.valid');
    const isCashed = this.utils.getNestedValue(this.cargo, 'shippingCost.cashed');
    if (isCashed && this.isSatelliteLockService)
      return { show: true, canModify: false, error: 'No se pueden agregar bonificaciones y descuentos a servicios de candado satelital facturados.' };
    if (isValidated && this.isSatelliteLockService)
      return { show: true, canModify: false, error: 'No se pueden agregar bonificaciones y descuentos a servicios de candado satelital validados para facturar.' };
    if (isCashed && (isPaid || this.hasBalanceAndIsPaid))
      return { show: true, canModify: false, error: 'No se pueden agregar bonificaciones y descuentos a servicios facturados y pagados.' };
    if (isValidated && (isPaid || this.hasBalanceAndIsPaid))
      return { show: true, canModify: false, error: 'No se pueden agregar bonificaciones y descuentos a servicios validados para facturar y pagados.' };
    if ((isPaid || this.hasBalanceAndIsPaid) && !fullAccessPermission)
      return { show: true, canModify: false, error: 'Se requiere un permiso especial para realizar modificaciones en este servicio' };
    return { show: true, canModify: true, error: '' };
  }

  /**
  * This method allows to delete the load.
  */
  public async btnDeleteCarga(type?: string, load?: Cargo) {
    if (load) this.cargo = load;
    if (this.blockDocumentMutation()) return;
    if (this.cargo && this.cargo.state === CargoStateEnum.EXPIRED)
      return this.errorMessageDeleteCargo("Los servicios expirados no se pueden eliminar");
    const cargoCreator: string = this.utils.getNestedValue(this.cargo, 'numberDocumentCreatorLoad');
    const userLogged: string = this.authService && this.utils.getNestedValue(this.authService.getUserSession(), 'information.document');
    const hasPermissionUnrestricted: boolean = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.removeCargoUnrestricted);
    if ((cargoCreator && userLogged && cargoCreator === userLogged) || hasPermissionUnrestricted)
      this.confirmRemoveCargo(type);
    else if (cargoCreator && userLogged && cargoCreator !== userLogged) {
      const user: User = await this.getDetailUserClientByDocument(cargoCreator);
      const userName: string = this.utils.getNestedValue(user, 'information.name');
      const userEmail: string = this.utils.getNestedValue(user, 'email');
      this.errorMessageDeleteCargo(`Contacte al creador del servicio ${userName ? userName : ''}${userEmail ? ' al correo ' + userEmail : ''} para anular el servicio`);
    } else this.errorMessageDeleteCargo();
  }
  /**
  * This method open a dialog with an specific message error when the user try to delete a load.
  * @param {string | User} condition (string | User - optional) evaluates the condition of the load and depends on this shows one message or the other message.
  */
  errorMessageDeleteCargo(title: string = "Contacte a Soporte para anular el servicio") {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title,
      iconError: true,
      hideBtnConfirm: true,
      resize: true
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  /**
   * Un servicio consolidado no puede cambiar de compañía asociada: el
   * contratante lo define el consolidado al que pertenece.
   */
  get showBtnChangeCompany(): { show: boolean, error?: string, disabled?: boolean } {
    if (!this.cargo) return { show: false };
    if ([CargoStateEnum.DELETED, CargoStateEnum.EXPIRED, CargoStateEnum.REQUEST].includes(this.cargo.state))
      return { show: false };
    if (this.utils.isDefined(this.cargo.consecutiveMainCargo))
      return { show: true, error: ServiceMessages.CONSOLIDATED_CARGO_CONTRACTOR_NOT_EDITABLE, disabled: true };
    return { show: true, error: '', disabled: false };
  }

  get showBtnLinkServices(): { show: boolean, error?: string, disabled?: boolean } {
    if (!this.cargo) return { show: false };
    if (!this.isRootNit) return { show: false };
    if (![CargoStateEnum.CREATED, CargoStateEnum.ACCEPTED, CargoStateEnum.START_SERVICE].includes(this.cargo.state))
      return { show: false };
    if (!this.isTransportService) return { show: false };
    if (this.cargo.consecutiveMainCargo)
      return { show: true, error: `El servicio ya pertenece al servicio principal ${this.cargo.consecutiveMainCargo}`, disabled: true };
    if (this.cargo.subCargos && this.cargo.subCargos.length)
      return { show: true, error: `El servicio es el consolidado de ${this.cargo.subCargos.length} servicios secundarios`, disabled: true };
    if (this.cargo.manifestAuthorization)
      return { show: true, error: 'El servicio ya tiene un manifiesto generado', disabled: true };
    return { show: true, error: '', disabled: false };
  }

  openLinkServices() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(LinkServicesComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (!result || !result.state) return;
      if (this.type === 'button') this.refreshCargo.emit(this.cargo.consecutive);
      else this.refreshListCargo.emit();
    });
  }

  /**
   * Un servicio consolidado se puede desasociar solo si no ha terminado su ciclo
   * y no tiene manifiesto generado. La acción disuelve el grupo completo.
   */
  get showBtnUnlinkServices(): { show: boolean, error?: string, disabled?: boolean } {
    if (!this.cargo) return { show: false };
    if (!this.isRootNit) return { show: false };
    if (!this.isTransportService) return { show: false };
    if (!this.utils.isDefined(this.cargo.consecutiveMainCargo)) return { show: false };
    if ([CargoStateEnum.END_SERVICE, CargoStateEnum.EXPIRED, CargoStateEnum.DELETED].includes(this.cargo.state))
      return {
        show: true,
        error: Fmt.string(ServiceMessages.UNLINK_CONSOLIDATED_INVALID_STATE, CargoStateDict[this.cargo.state]),
        disabled: true
      };
    if (this.cargo.manifest || this.cargo.manifestAuthorization)
      return { show: true, error: ServiceMessages.UNLINK_CONSOLIDATED_HAS_MANIFEST, disabled: true };
    return { show: true, error: '', disabled: false };
  }

  async openUnlinkServices() {
    const mainConsecutive = this.cargo.consecutiveMainCargo;
    const { confirm } = await this.cargoManager.openDialogConfirm(
      Fmt.string(ServiceMessages.UNLINK_CONSOLIDATED_CONFIRM_TITLE, `${mainConsecutive}`),
      ServiceMessages.UNLINK_CONSOLIDATED_CONFIRM_DESCRIPTION
    );
    if (!confirm) return;
    this.spinner.show();
    this.cargoListService.unlinkConsolidatedService(mainConsecutive).subscribe(
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.UNLINK_CONSOLIDATED_SUCCESS, undefined, 'success');
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      },
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.UNLINK_CONSOLIDATED_ERROR, undefined, 'error');
      }
    );
  }

  get showBtnReplicateService(): { show: boolean, error?: string, disabled?: boolean } {
    if (!this.cargo) return { show: false };
    if (this.cargo.state !== CargoStateEnum.REQUEST) return { show: false };
    return { show: true, error: '', disabled: false };
  }

  openReplicateService() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(ReplicateServiceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (!result || !result.state) return;
      if (this.type === 'button') this.refreshCargo.emit(this.cargo.consecutive);
      else this.refreshListCargo.emit();
    });
  }

  /**
  * This method brings the information of a user according to the userdocument.
  * @param {string} userDocument (string) is the document of the user that needs to consult.
  */
  public getDetailUserByDocument(userDocument: string) {
    return new Promise((resolve, reject) => {
      this.adminUserService.getUsersDetailByDocument(userDocument).subscribe(
        (success: User) => {
          resolve(success);
        },
        (error) => {
          reject();
        }
      );
    });
  }
  /**
  * This method brings the information of a client according to the userdocument.
  * @param {string} userDocument (string) is the document of the client that needs to consult.
  */
  public getDetailUserClientByDocument(userDocument: string) {
    return new Promise((resolve, reject) => {
      this.adminUserService.getUserClientByDocument(userDocument).subscribe(
        (success: UserClient[]) => {
          if (success && success.length) resolve(success[0]);
          else reject();
        },
        (error) => {
          reject();
        }
      );
    });
  }
  /**
  * This method open a dialog window that allow the user to renew the load.
  */
  openRenewDate() {
    const creationDate = DateManager.stringToDate(this.cargo.creationDate, 'YYYY-MM-DD HH:mm Z');
    const limitDate = DateManager.stringToDate('2024-01-15', 'YYYY-MM-DD');
    if (DateManager.isBefore(creationDate, limitDate, "days")) {
      this.snackBarService.openSnackBar(CargoMessages.INVALID_DATE_RESTORE_LOAD, undefined, 'alert');
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(CargoRenewDatesComponent, dialogConfig);
  }
  /**
  * This method open a dialog window that allow the user to create a rounded load.
  */
  openRoundedCargo() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.cargo;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(RoundedCargoComponent, dialogConfig);
  }
  /**
  * This method open a dialog that asks the user if wanted to approve the pay of the balance of the load.
  */
  public openDialogApprovePayBalance(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title:
        "¿Deseas Aprobar el Pago del Saldo del servicio " +
        this.cargo.consecutive +
        " para la placa " +
        this.cargo.licensePlate +
        "?",
      showYesBtn: true,
      showNoBtn: true,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (!this.utils.isEmpty(result) && !this.utils.isEmpty(result.state)) {
        this.approvePayBalance(result.state);
      }
    });
  }
  /**
  * This method allows to approve or reject the balance pay.
  * @param {boolean} approve (boolean) is the response of the user if approve or reject the balance pay.
  */
  private approvePayBalance(approve: boolean): void {
    this.cargoItemService.approvePayBalance(this.cargo.id, approve).subscribe(
      (cargo: Cargo) => {
        if (
          !this.utils.isEmpty(cargo) &&
          !this.utils.isEmpty(cargo.shippingCost) &&
          !this.utils.isEmpty(cargo.shippingCost.approveBalance)
        ) {
          this.refreshListCargo.emit();
          this.refreshCargo.emit(this.cargo.consecutive);
          this.snackBarService.openSnackBar(
            "El pago del saldo ha sido " +
            (cargo.shippingCost.approveBalance ? "aprobado" : "rechazado") +
            " correctamente"
          );
        } else {
          this.snackBarService.openSnackBar(
            "Ocurrió un error " +
            (cargo.shippingCost.approveBalance ? "aprobando" : "rechazando") +
            " el pago del saldo",
            undefined,
            "error"
          );
        }
      },
      (error) => {
        this.snackBarService.openSnackBar(
          "Ocurrió un error registrando la acción del pago del saldo",
          undefined,
          "error"
        );
      }
    );
  }
  /**
  * This method open a dialog window to add a new location report of the vehicle of the load.
  */
  public openCargoLocationReport(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.disableClose = true;
    const dialogRef = this.matDialog.open(
      CargoLocationReportComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      this.refreshListCargo.emit();
      if (!this.utils.isEmpty(result) && !this.utils.isEmpty(result.state)) {
        this.snackBarService.openSnackBar("Registro agregado correctamente");
        this.executeParentMethod.emit('refreshLocations');
      }
    });
  }
  /**
 * This method allows to verified if is possible to open the request of the advance or to cancel the advance requested.
 * @param {string} request (string) indicates the type of query if is request advance or cancel the advance requested.
 */
  canOpenRequestAdvance(request: 'RequestAdvance' | 'CancelRequest') {
    const assignedVehicleFingerprintUserId = this.utils.getNestedValue(this.cargo, 'assignedVehicleFingerPrint.userId');
    const assignedVehicleFingerprintUserName = this.utils.getNestedValue(this.cargo, 'assignedVehicleFingerPrint.userName');
    const authServiceUserId = this.authService.getUserSession().information && this.authService.getUserSession().information.document
      ? this.authService.getUserSession().information.document : '';
    if (!authServiceUserId)
      return this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, "error");
    if (assignedVehicleFingerprintUserId !== authServiceUserId && !this.permissionToRequestAdvanceUnrestricted)
      return this.dialogMessage(
        `No es posible solicitar el pago de anticipo. La solicitud debe ser realizada por la persona que asignó el vehículo. 
        ${assignedVehicleFingerprintUserName ? `Por favor, contacte a ${assignedVehicleFingerprintUserName}.` : ''} 
        ${this.isTeclogiUser ? ' En caso de no poder hacerlo, comuníquese con Dirección de Operaciones.' : ''}`,
        '',
        true,
        true
      );
    if (request === 'RequestAdvance' && this.cargo.state === CargoStateEnum.ACCEPTED && !this.permissionToRequestAdvanceUnrestricted)
      return this.dialogMessage(
        `No es posible solicitar el pago de anticipo. El servicio se encuentra en estado aceptado, para poder solicitar el pago de anticipo
         en este estado debe contar con un permiso adicional.`,
        '',
        true,
        true
      );
    this.requestAdvance(request);

  }
  get isTeclogiUser(): boolean {
    return this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }

  requestAdvance(request: string) {
    if (
      this.cargo &&
      this.cargo.cargoFeature &&
      this.cargo.cargoFeature.uploadDownload &&
      this.cargo.cargoFeature.uploadDownload.origin &&
      this.cargo.cargoFeature.uploadDownload.origin.addresses &&
      this.cargo.cargoFeature.uploadDownload.origin.addresses.length >= 0
    ) {
      let address = this.cargo.cargoFeature.uploadDownload.origin.addresses[0];
      if (address) {
        this.spinner.show();
        this.cargoEvidenceService.getImageByAddress(this.cargo.id, address.address, address.id)
          .pipe(
            finalize(() => {
              this.spinner.hide();
              this.setStatusAdvanceMessage(request);
            })
          )
          .subscribe(
            (data) => {
              if (data !== null) this.canOpenRequestAdvanceModal = true;
              else this.canOpenRequestAdvanceModal = false;
            },
            (error) => {
              this.canOpenRequestAdvanceModal = false;
              console.error(error);
            }
          );
      }
      else {
        this.canOpenRequestAdvanceModal = false;
      }
    }
  }
  /**
  * This method set the advance message this could be an error or an information message.
  * @example
  * @param {Date | string} date (Date or string) is the date to use
  * @param {string} request (string) indicates the type of query if is request advance or cancel the advance requested.
  */
  setStatusAdvanceMessage(request: string) {
    /* ERROR RNDC if (
      this.cargo.ministry && !this.permissionToRequestAdvanceUnrestricted &&
      (!this.cargo.manifest || !this.cargo.manifestAuthorization)
    )
      this.cannotRequestAdvanceReason =
        CargoMessages.NO_MANIFEST;
    else */ if (
      this.cargo.state === CargoStateEnum.START_SERVICE &&
      !this.canOpenRequestAdvanceModal && !this.permissionToRequestAdvanceUnrestricted
    )
      this.cannotRequestAdvanceReason =
        CargoMessages.NO_UPLOAD_EVIDENCES;
    else if (this.cargo.shippingCost && !this.cargo.shippingCost.valueAdvance && this.authService && this.authService.getCompany().companyId !== '8000130291')
      this.cannotRequestAdvanceReason =
        CargoMessages.VALUE_ADVANCE_ON_ZERO;
    else if (
      this.cargo.shippingCost &&
      !this.cargo.shippingCost.paid === false
    )
      this.cannotRequestAdvanceReason =
        CargoMessages.SHIPPING_COST_PAID;
    else if (
      this.cargo.shippingCost &&
      !this.cargo.shippingCost.advanceState === false
    )
      this.cannotRequestAdvanceReason =
        CargoMessages.ADVANCE_STATE_PAID;
    else
      if (this.cargo.shippingCost && !this.cargo.shippingCost.valueAdvance)
        this.cannotRequestAdvanceReason =
          CargoMessages.VALUE_ADVANCE_ON_ZERO;
      else if (
        this.cargo.shippingCost &&
        !this.cargo.shippingCost.paid === false
      )
        this.cannotRequestAdvanceReason =
          CargoMessages.SHIPPING_COST_PAID;
      else if (
        this.cargo.shippingCost &&
        !this.cargo.shippingCost.advanceState === false
      )
        this.cannotRequestAdvanceReason =
          CargoMessages.ADVANCE_STATE_PAID;
      else
        if (this.cargo.shippingCost && this.cargo.shippingCost.requestedAdvance &&
          this.cargo.shippingCost.requestedAdvance.fingerprint && this.cargo.shippingCost.requestedAdvance.requested) {
          this.cannotRequestAdvanceReason =
            `Solicitado por ${this.cargo.shippingCost.requestedAdvance.fingerprint.userName}
        (${this.cargo.shippingCost.requestedAdvance.fingerprint.userId})
        ${this.dateFormatPipe.transform(this.cargo.shippingCost.requestedAdvance.fingerprint.date, "only-date")}`
        }
        else this.cannotRequestAdvanceReason = CargoMessages.SHOW_REQUEST;


    if (this.disabledRequestAdvance) {
      this.openDialogError(this.cannotRequestAdvanceReason);
    } else {
      let fingerPrint = '';
      request && request === 'CancelRequest' ? fingerPrint = this.cannotRequestAdvanceReason : '';
      this.openDialogRequestAdvance(request, fingerPrint);
    }
  }
  /**
  * This method open a dialog window that shows to the user an error message depends on the value of the parameter.
  * @param {string} title (string) is the error message.
  */
  openDialogError(title: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      iconError: true,
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  get disabledRequestAdvance() {
    return this.cannotRequestAdvanceReason &&
      this.cannotRequestAdvanceReason !== CargoMessages.SHOW_REQUEST &&
      this.cannotRequestAdvanceReason.split(' ')[0] !== 'Solicitado';
  }

  get canAddTrackingReports(): { canAdd: boolean, reason?: string } {
    if (this.cargo && this.cargo.stateTracking === CargoStateEnum.END_SERVICE)
      return { canAdd: false, reason: 'No es posible añadir seguimientos, el servicio ha finalizado' };
    return { canAdd: true };
  }
  /**
  * This method open a dialog to confirm the request of the advance of the load.
  * @param {string} request (string) indicates if is request advance or cancel the advance requested.
  * @param {string} description (string - optional) is a fingerprint.
  */
  public openDialogRequestAdvance(request: string, description?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
      request: request,
      description: description ? description : ''
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.matDialog.open(
      CargoRequestAdvanceComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (!this.utils.isEmpty(result) && !this.utils.isEmpty(result.state)) {
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      }
    });
  }
  /**
  * This method download the novelties report of the load.
  */
  public downloadReport(): void {
    this.spinner.show();
    this.cargoService.downloadCargoTraceability(this.cargo.id).subscribe(
      (response) => {
        if (!this.utils.isEmpty(response)) {
          this.utils.downloadFile(
            response,
            "Reporte Servicio " + this.cargo.consecutive
          );
        } else {
          this.snackBarService.openSnackBar(
            "No hay reportes registrados para el servicio " +
            this.cargo.consecutive,
            undefined,
            "alert"
          );
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(
          "Ocurrió un error al descargar el reporte del servicio " +
          this.cargo.consecutive,
          undefined,
          "error"
        );
      }
    );
  }

  get canRequestFastPayment(): boolean {
    return this.cargo && this.cargo.state === CargoStateEnum.END_SERVICE && !this.cargo.fastPayment && this.cargo.approval !== 'Rejected' && this.isTransportService
      && this.balanceState && this.authService && !!this.authService.getCompanySaaS() && !!this.authService.getCompanySaaS().fastPaymentEnabled && !this.hasBalanceAndIsPaid;
  }
  /**
  * This method open a dialog window and in this window asks the user for the approval or rejection of the fast payment of the load.
  * @param {string} idCargo (string) is the identifier of the load.
  * @param {number} consecutive (number) is the consecutive of the load.
  * @param {boolean} state (boolean) is decision of the user could be approve or reject.
  * @param {string} tripType (string) is tripType of the load.
  */
  openDialogFastPayment(idCargo: string, consecutive: number, state: boolean, tripType: string) {
    const dialogConfig = new MatDialogConfig();
    const title = state ? 'solicitar el' : 'cancelar la solicitud del';
    dialogConfig.data = {
      title: `¿Está seguro que quiere ${title} pronto pago para el servicio #${consecutive}?`,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) {
        this.approveFastPayment(idCargo, state, tripType)
      }
    });
  }

  /**
 * This method approved or reverse the fast payment.
 * @param {string} idCargo (string) is the identifier of the load.
 * @param {boolean} state (boolean) is parameter that indicates if is al approval or a reverse of the fast payment.
 * @param {string} tripType (string) is a parameter to set an exception sended to backend.
 */
  approveFastPayment(idCargo: string, state: boolean, tripType: string) {
    const fastPaymentObserver = {
      next: () => {
        this.spinner.hide();
        state ? this.snackBarService.openSnackBar(CargoMessages.SUCCESS_FAST_PAYMENT, undefined, "success") :
          this.snackBarService.openSnackBar(CargoMessages.SUCCESS_FAST_PAYMENT_REVERT, undefined, "success");
        this.refreshListCargo.emit();
        this.refreshCargo.emit(this.cargo.consecutive);
      },
      error: (error) => {
        this.spinner.hide();
        if (error && error.error && error.error.message) {
          this.snackBarService.openSnackBar(error.error.message, undefined, 'error');
        } else {
          this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        }
      },
      complete: () => {
        this.spinner.hide();
      }
    };
    this.spinner.show();
    this.cargoOptionsService.fastPayment(idCargo, state, tripType).subscribe(fastPaymentObserver);
  }
  /**
  * This method open a dialog window that asks the user if wanted to restart the load.
  * @param {number} consecutive (number) is the consecutive of the load.
  * @param {string} cargoId (string) is the identifier of the load.
  */
  openDialogRestartCargo(consecutive: number, cargoId: string) {
    if (this.showRestartCargo) {
      this.snackBarService.openSnackBar(CargoMessages.PAYMENTS_IN_CARGO, undefined, 'alert');
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `¿Está seguro que quiere reiniciar el servicio #${consecutive}?`,
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.state) this.restartCargo(consecutive, cargoId)
    });
  }
  /**
  * This method consumes the service that restart a load.
  * @param {number} consecutive (string) is the consecutive of the load.
  * @param {string} cargoId (string) is the identifier of the load.
  */
  restartCargo(consecutive: number, cargoId: string) {
    const restartCargoObserver = {
      next: () => {
        this.snackBarService.openSnackBar(CargoMessages.SUCCESS_RESTART_LOAD, undefined, "success");
        this.router.navigate(["cargo/tracking/", consecutive.toString()]);
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        if (error && error.error && error.error.message) {
          this.snackBarService.openSnackBar(error.error.message, undefined, 'error');
        } else {
          this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        }
      },
      complete: () => {
        this.spinner.hide();
      }
    };
    this.spinner.show();
    this.cargoOptionsService.restartCargo(cargoId).subscribe(restartCargoObserver);
  }

  openMoveAdvance() {
    const config = new MatDialogConfig();
    config.data = { cargos: [this.cargo] };
    config.maxHeight = ModalEnum.MAX_HEIGHT;
    config.width = ModalEnum.SMALL_WIDTH;
    config.maxWidth = ModalEnum.MAX_WIDTH;

    this.matDialog.open(MoveAdvanceDialogComponent, config);
  }

  get showRestoreCargo(): boolean {
    return [CargoStateEnum.END_SERVICE, CargoStateEnum.EXPIRED, CargoStateEnum.DELETED].includes(this.cargo.state);
  }

  get showRestartCargo(): boolean {
    return !!(this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.payments && this.cargo.shippingCost.payments.length && this.cargo.shippingCost.payments.some(payment => payment.type === 'balance'))
  }

  get showCreateRoundedCargo() {
    if (
      this.cargo &&
      (this.cargo.state === CargoStateEnum.END_SERVICE ||
        this.cargo.state === CargoStateEnum.START_SERVICE)
    ) {
      return true;
    } else {
      return false;
    }
  }

  get canReadManifest() {
    return this.permissionRole.hasPermission("cargo", "readManifest");
  }

  get PDFTypes() {
    return PDFTypes;
  }

  get isEscortedService(): boolean {
    return this.utils.isEscortedService(this.cargo);
  }
  get isSatelliteLockService(): boolean {
    return this.utils.isSatelliteLockService(this.cargo);
  }
  get isTransportService(): boolean {
    return this.utils.isTransportService(this.cargo);
  }

  get hasManifestPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.documentManifest);
  }
  get hasCancelManifestPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.cancelManifest);
  }
  get hasConsignmentPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.documentConsignment);
  }

  get canSeeConsignments(): boolean {
    return this.hasConsignmentPermission
      && this.cargo.ministry
      && ![CargoStateEnum.REQUEST, CargoStateEnum.EXPIRED].includes(this.cargo.state);
  }

  get canAccessConsignments(): { show: boolean, canAccess?: boolean, reason?: string } {
    if (!this.hasConsignmentPermission || !this.cargo || !this.cargo.ministry) return { show: false };
    if (this.isNegotiation) return { show: false };
    if ([CargoStateEnum.REQUEST, CargoStateEnum.EXPIRED].includes(this.cargo.state)) return { show: false };
    if (!this.consignmentAssociated) return { show: true, canAccess: false, reason: 'No hay remesas asociadas a este servicio' };
    return { show: true, canAccess: true };
  }
  get canCancelConsignment(): { show: boolean, canCancel?: boolean, reason?: string } {
    if (!this.hasConsignmentPermission || !this.cargo || !this.cargo.ministry) return { show: false };
    if (!this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.deleteConsignment)) return { show: false };
    if (this.documentRecreationInProgress)
      return { show: true, canCancel: false, reason: this.documentRecreationInProgressMessage };
    if (!this.consignmentAssociated)
      return { show: true, canCancel: false, reason: 'No hay remesas asociadas a este servicio' };
    if (this.cargo.manifestAuthorization)
      return { show: true, canCancel: false, reason: 'Las remesas con manifiesto generado no se pueden anular, debe anular el manifiesto primero' };
    if (![CargoStateEnum.ACCEPTED, this.cargoStateEnum.CREATED, this.cargoStateEnum.START_SERVICE].includes(this.cargo.state))
      return { show: true, canCancel: false, reason: 'No es posible anular las remesas asociadas a este servicio en este estado' };
    return { show: true, canCancel: true };
  }
  get consignmentAssociated(): number {
    return this.utils.getCargoAssociatedConsignments(this.cargo).length;
  }
  get hasManifestUrbanPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.documentManifestUrban);
  }
  get hasConsignmentUrbanPermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.documentConsignmentUrban);
  }
  get hasOrderVehiclePermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.documentOrderVehicle);
  }
  get hasPlanningRoutePermission(): boolean {
    return this.permissionRole.hasPermission(this.permission.routes.module, this.permission.routes.accessCargoRoutePlanning);
  }
  get isUrbanService(): boolean {
    return this.utils.isSameCity(this.cargo);
  }

  get balanceState(): boolean {
    return this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.payments && this.cargo.shippingCost.payments.length ? this.cargo.shippingCost.payments.every(payment => payment.type !== 'balance') : true;
  }

  public async balance() {
    const balanceState = !!this.utils.getNestedValue(this.cargo, 'shippingCost.balanceState');
    const balance = balanceState ?
      this.cargoItemService.getCargoBalancePaid(this.cargo) :
      await this.cargoPaymentsService.getBalance(this.cargo, false, this.cargo.travelExpenses);
    return balance;
  }

  get haveAdvancePayments(): boolean {
    return !!(this.cargo && this.cargo.shippingCost && this.cargo.shippingCost.advanceState && this.cargo.shippingCost.payments && this.cargo.shippingCost.payments.length && this.cargo.shippingCost.payments.some(payment => payment.type === 'advance'))
  }

  get showCancelAdvance() {
    return (this.cargo &&
      this.cargo.state === CargoStateEnum.START_SERVICE &&
      this.cargo.shippingCost &&
      this.cargo.shippingCost.requestedAdvance &&
      this.cargo.shippingCost.requestedAdvance.requested)
  }

  get permissionToRequestAdvanceUnrestricted(): boolean {
    return this.permissionRole.hasPermission(Permission.payments.module, Permission.payments.unrestrictedAdvancePaymentsRequest);
  }

  get isPrincipalCompany(): boolean {
    return !!(this.listCompanies.length && this.company && this.company.companyId && this.listCompanies.some(company => company.nit === this.company.companyId));
  }

  get cargoStateEnum(): typeof CargoStateEnum {
    return CargoStateEnum;
  }

  get rndcContingencyActive(): boolean {
    return this.rndcContingencyActiveValue;
  }
  get showCancelManifestOption(): boolean {
    if (!this.cargo) {
      return false;
    }
    return [CargoStateEnum.ACCEPTED, CargoStateEnum.START_SERVICE].includes(this.cargo.state)
      && !!this.cargo.manifest
      && !!this.cargo.ministry
      && this.hasManifestPermission
      && this.hasCancelManifestPermission;
  }

  get documentRecreationInProgress(): boolean {
    return isDocumentRecreationInProgress(this.cargo);
  }

  private blockDocumentMutation(): boolean {
    if (!this.documentRecreationInProgress) return false;
    this.snackBarService.openSnackBar(
      this.documentRecreationInProgressMessage,
      undefined,
      'alert'
    );
    return true;
  }


  get canOpenManifestPdfByRules(): boolean {
    if (this.rndcContingencyActive) return true;
    const hasManifestAuthorization = !!(this.cargo && this.cargo.manifestAuthorization);
    const authorizedWithoutManifest = !!(this.cargo && this.cargo.authorizedWithoutManifest);
    return hasManifestAuthorization || authorizedWithoutManifest;
  }

  private registerRndcContingencyListener(): void {
    CargoOptionsComponent.rndcContingencyInstances.add(this);
    this.rndcContingencyActiveValue = CargoOptionsComponent.rndcContingencyActive;
    this.loadCannotShowManifestReason();

    if (CargoOptionsComponent.rndcContingencySub) return;

    let firstEmission = true;
    CargoOptionsComponent.rndcContingencySub = this.generalConfigService.rndcContingency$.subscribe((value: boolean) => {
      CargoOptionsComponent.rndcContingencyActive = value;
      CargoOptionsComponent.rndcContingencyInstances.forEach((instance: CargoOptionsComponent) => {
        instance.applyRndcContingency(value, !firstEmission);
      });
      firstEmission = false;
    });
  }

  private applyRndcContingency(value: boolean, detectChanges: boolean): void {
    if (this.isDestroyed) return;
    this.rndcContingencyActiveValue = value;
    this.loadCannotShowManifestReason();
    if (detectChanges) this.cdref.detectChanges();
    else this.cdref.markForCheck();
  }

  private unregisterRndcContingencyListener(): void {
    CargoOptionsComponent.rndcContingencyInstances.delete(this);
    if (!CargoOptionsComponent.rndcContingencyInstances.size && CargoOptionsComponent.rndcContingencySub) {
      CargoOptionsComponent.rndcContingencySub.unsubscribe();
      CargoOptionsComponent.rndcContingencySub = null;
    }
  }

  public belowSicetac(cargo: SicetacResponse, path?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const formatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });
    const min = formatter.format(cargo.minimumApprovedValueSicetac);
    if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approvedBelowSicetac)) {
      if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
        dialogConfig.data = {
          title: '¿Desea aprobar el flete por debajo del SICETAC?',
          descriptionHTML: `El flete mínimo permitido por SICETAC es de <strong>${min}</strong>, si desea ajustarlo por favor realice una bonificación para ajustarse al valor mínimo permitido.`,
          btnDetailCargo: true,
          path: path,
          closeModal: true,
        };
        dialogConfig.disableClose = true;
        const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          if (result && result.state) {
            this.cargoService.approvedBelowSiceTac(this.cargo.id).subscribe(
              () => {
                this.openConfirmBelowSicetac();
                this.refreshListCargo.emit();
                this.refreshCargo.emit(this.cargo.consecutive);
              },
              (error) => {
                this.snackBarService.openSnackBar("No se pudo aprobar", undefined, 'error');
              }
            );
          }
        })
      }
    } else {
      if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
        dialogConfig.data = {
          title: `El flete mínimo es ${min}, por favor realice una bonificación para ajustarse al valor mínimo permitido`,
          showBtn: true,
        };
        const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => { })
      }
    }
  }

  openConfirmBelowSicetac() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: `Aprobación exitosa`,
      icon: true,
      description: `Se ha aprobado el servicio por un flete que está por debajo del valor mínimo permitido por el SICETAC`,
      hideBtnCancel: false,
      hideBtnConfirm: true,
    };
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  private loadCannotShowManifestReason() {
    this.disableViewManifest = true;

    if (!this.cargo) {
      this.cannotShowManifestReason = DisableManifestReason.LOADING_CARGO;
      return;
    }

    const ministry = this.cargo.ministry === true;
    const manifest = !!this.cargo.manifest && this.cargo.manifest !== null;
    const canOpenManifest = this.canOpenManifestPdfByRules;
    const error = this.cargo.manifestError && this.cargo.manifestError.error && !this.rndcContingencyActive;

    if (ministry && error && !(manifest && canOpenManifest)) {
      this.cannotShowManifestReason = this.cargo.manifestError.error;
    } else if (ministry && !(manifest && canOpenManifest)) {
      this.cannotShowManifestReason = DisableManifestReason.NO_MANIFEST_RNDC;
    } else if (ministry && manifest && canOpenManifest) {
      this.disableViewManifest = false;
      this.cannotShowManifestReason = DisableManifestReason.SHOW_MANIFEST;
    } else {
      this.cannotShowManifestReason = DisableManifestReason.PRECONDITIONS_NOT_MET;
    }
  }

  public openDuplicateTransportRequest() {
    const creationDate = DateManager.stringToDate(this.cargo.creationDate, 'YYYY-MM-DD HH:mm Z');
    const limitDate = DateManager.stringToDate('2024-01-15', 'YYYY-MM-DD');
    if (DateManager.isBefore(creationDate, limitDate, "days"))
      return this.snackBarService.openSnackBar(CargoMessages.INVALID_DATE_RESTORE_LOAD, undefined, 'alert');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      cargo: this.cargo,
      isDuplicate: true
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.matDialog.open(CargoRenewDatesComponent, dialogConfig);
  }

  async getCargoVehicle(licensePlate: string) {
    try {
      const vehicle = await this.vehiclesService.getVehicleFromOwnCompany(licensePlate).toPromise();
      return vehicle ? vehicle : null;
    } catch (error) {
      return null;
    }
  }

  async getCargoConsignments(): Promise<ConsignmentCargo[]> {
    try {
      const consignments = await this.cargoDetailService.getCargoConsignments(this.cargo.id, 'Created').toPromise();
      return consignments && consignments.length ? consignments : [];
    } catch (error) {
      return [];
    }
  }

  private async checkCargoValidToContinue(checkTripTimes: boolean = false): Promise<{ canContinue: boolean }> {
    this.spinner.show();
    const vehicle = this.cargo.licensePlate ? this.vehicle ? this.vehicle : await this.getCargoVehicle(this.cargo.licensePlate) : null;
    const consignments = this.cargo.ministry ? await this.getCargoConsignments() : [];
    this.spinner.hide();
    const isValid = await this.serviceValidationManager.validateAllSectionsAndShowModal(this.cargo, vehicle, consignments, checkTripTimes);
    return { canContinue: isValid };
  }

  public get canOpenLogisticTimes(): { canView: boolean, canOpen?: boolean, reason?: string } {
    return this.utils.canOpenLogisticTimes(this.cargo);
  }

  public openLogisticTimes() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Registro de monitoreo de manifiesto',
      description: `Servicio seleccionado: ${this.cargo.consecutive}`,
      cargos: [this.cargo],
      manual_consignment_dates: false,
      date: true,
      untilNow: new Date(),
      type: 'logisticTimesModal'
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(ApproveCargoDialogComponent, dialogConfig).afterClosed().subscribe((result) => {
      if (!!result) this.changeLogisticTimes(result);
    });
  }

  changeLogisticTimes(result: any) {
    const changeLogisticsTimesObserver = {
      next: () => {
        this.snackBarService.openSnackBar(CargoMessages.SUCCESS_UPDATE, undefined, "success");
        this.refreshListCargo.emit();
      },
      error: (error: HttpErrorResponse) => {
        if (error.error && error.error.message) this.snackBarService.openSnackBar(error.error.message, undefined, 'error');
        else this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      }
    };
    this.spinner.show();
    this.cargoOptionsService.changeLogisticsTimes(result)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(changeLogisticsTimesObserver);
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    this.unregisterRndcContingencyListener();
    this.cdref.detach();
  }
}
